import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import { FiltroTipoHabilitacion, coincideTipo } from "../../Materiales/Habilitacion/TiposHabilitacion";
import Baja from "../../Baja";
import { v4 as uuidv4 } from "uuid";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Status from "../../Status";
import moment from "moment";
import BajaMultiple from "../../BajaMultiple";
import { pdfOrdenProduccion } from "./pdfOrdenProduccion";
import EditarOrdenProduccion from "./EditarOrdenProduccion";


// Renglon del pedido de un renglon de orden de maquila. Las ordenes nuevas lo
// traen directo (`articulosPedido`); las historicas llegan por la orden de
// produccion, que ya no existe en el flujo.
const renglonPedido = (a) =>
  a?.articulosPedido?.[0] ?? a?.articulosOrdenesCorte?.[0]?.articulosPedido?.[0];

function ListadoCortes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_CORTES = process.env.REACT_APP_URL_CORTES;
  const URL_ARTICULOS_CORTES = process.env.REACT_APP_URL_ARTICULOS_CORTES;
  const URL_AVISOS_ENTREGA = process.env.REACT_APP_URL_AVISOS_ENTREGA;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_ARTICULOS_PROCESOS_SALIDA =
    process.env.REACT_APP_URL_ARTICULOS_PROCESOS_SALIDA;
  const URL_PROCESOS_ENTRADA = process.env.REACT_APP_URL_PROCESOS_ENTRADA;
  const URL_ARTICULOS_PROCESOS_ENTRADA =
    process.env.REACT_APP_URL_ARTICULOS_PROCESOS_ENTRADA;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_HABILITACION_CORTES = process.env.REACT_APP_URL_HABILITACION_CORTES;
  const URL_DETALLE_HABILITACION_CORTES = process.env.REACT_APP_URL_DETALLE_HABILITACION_CORTES;
  const URL_FALTANTES_PROVEEDORES =
    process.env.REACT_APP_URL_FALTANTES_PROVEEDORES;
  const URL_ENTRADAS_ALMACEN = process.env.REACT_APP_URL_ENTRADAS_ALMACEN;
  const URL_ENTRADAS_ALMACEN_ACUMULADOS =
    process.env.REACT_APP_URL_ENTRADAS_ALMACEN_ACUMULADOS;
  const URL_ENTRADAS_ALMACEN_COMPLETA =
    process.env.REACT_APP_URL_ENTRADAS_ALMACEN_COMPLETA;
  const ALMACEN = process.env.REACT_APP_ALMACEN;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [cortes, setCortes] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [areasEntrada, setAreasEntrada] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [selectedCorte, setSelectedCorte] = useState("");
  const [selectedCorteNumero, setSelectedCorteNumero] = useState("");
  const [modalProcesosSalida, setModalProcesosSalida] = useState(false);
  const toggleProcesosSalida = () =>
    setModalProcesosSalida(!modalProcesosSalida);
  const [articulosCortes, setArticulosCortes] = useState([]);
  const [articulosProcesosSalida, setArticulosProcesosSalida] = useState([]);
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [idCatalogoProcesos, setIdCatalogoProcesos] = useState("");
  const [nombreProcesosSalida, setNombreProcesosSalida] = useState("");
  const [idArticulo, setIdArticulo] = useState("");
  const [nombreArticulo, setNombreArticulo] = useState("");
  const [idPedido, setIdPedido] = useState("");
  const [numeroPedido, setNumeroPedido] = useState("");
  const [modalFuncionProcesosSalida, setModalFuncionProcesosSalida] =
    useState(false);
  const toggleFuncionProcesosSalida = () =>
    setModalFuncionProcesosSalida(!modalFuncionProcesosSalida);
  const [fechaProceso, setFechaProceso] = useState(endDate);
  const [fechaCompromisoProceso, setFechaCompromisoProceso] = useState(endDate);
  const [maquileroProceso, setMaquileroProceso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [observacionesMaquila, setObservacionesMaquila] = useState();
  const [precioProceso, setPrecioProceso] = useState(0);
  const [proveedores, setProveedores] = useState([]);
  const [totalPiezas, setTotalPiezas] = useState(0);
  const [totalPiezasFaltantes, setTotalPiezasFaltantes] = useState(0);
  const [totalPiezasSegundas, setTotalPiezasSegundas] = useState(0);
  const [totalGeneral, setTotalGeneral] = useState(0);
  const [fechaCancelacion, setFechaCancelacion] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);

  const [fecha, setFecha] = useState(endDate);
  const [plazo, setPlazo] = useState("");

  const [numero_corte, setNumeroCorte] = useState("");

  const [idEdit, setIdEdit] = useState("");

  const [editHab, setEditHab] = useState([]);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);

  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [precioEdit, setPrecioEdit] = useState("");
  const [fechaEdit, setFechaEdit] = useState("");
  const [fechaCompromisoEdit, setFechaCompromisoEdit] = useState("");
  const [observacionesEditProceso, setObservacionesEditProceso] = useState("");
  const [modalMaquileroEdit, setModalMaquileroEdit] = useState(false);
  const toggleMaquileroEdit = () => setModalMaquileroEdit(!modalMaquileroEdit);

  const [observacionesEdit, setObservacionesEdit] = useState("");
  const [statusTelaEdit, setStatusTelaEdit] = useState("");
  const [modalObservacionesEdit, setModalObservacionesEdit] = useState(false);
  const toggleObservacionesEdit = () => setModalObservacionesEdit(!modalObservacionesEdit);

    const [observacionesMaquilaEdit, setObservacionesMaquilaEdit] = useState("");
  const [modalObservacionesMaquilaEdit, setModalObservacionesMaquilaEdit] = useState(false);
  const toggleObservacionesMaquilaEdit = () => setModalObservacionesMaquilaEdit(!modalObservacionesMaquilaEdit);

  const [modalEditHab, setModalEditHab] = useState(false);
  const toggleEditHab = () => setModalEditHab(!modalEditHab);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [articulosEntrada, setArticulosEntrada] = useState([]);
  const [articulosUnicosEntrada, setArticulosUnicosEntrada] = useState([]);
  const [nombreProcesosEntrada, setNombreProcesosEntrada] = useState("");
  const [articulosProcesosEntrada, setArticulosProcesosEntrada] = useState([]);
  const [selectedProcesoSalida, setSelectedProcesoSalida] = useState("");

  const [modalProcesosEntrada, setModalProcesosEntrada] = useState(false);
  const toggleProcesosEntrada = () =>
    setModalProcesosEntrada(!modalProcesosEntrada);
  const [modalFuncionProcesosEntrada, setModalFuncionProcesosEntrada] =
    useState(false);
  const toggleFuncionProcesosEntrada = () =>
    setModalFuncionProcesosEntrada(!modalFuncionProcesosEntrada);

  const [entregaHabilitacion, setEntregaHabilitacion] = useState(false);
  const [habilitacion, setHabilitacion] = useState([]);

  const [modalFaltante, setModalFaltante] = useState(false);
  const toggleFaltante = () => setModalFaltante(!modalFaltante);
  const [precioFaltante, setPrecioFaltante] = useState(0);
  const [precioFaltanteHab, setPrecioFaltanteHab] = useState(0);
  const [cantidadFaltante, setCantidadFaltante] = useState(0);
  const [cantidadFaltanteHab, setCantidadFaltanteHab] = useState(0);
  const [totalFaltante, setTotalFaltante] = useState(0);
  const [totalTotalFaltante, setTotalTotalFaltante] = useState(0);
  const [totalFaltanteHab, setTotalFaltanteHab] = useState(0);
  const [procesoSalidaFaltante, setProcesoSalidaFaltante] = useState("");
  const [idMaquileroFaltante, setIdMaquileroFaltante] = useState("");
  const [fechaFaltante, setFechaFaltante] = useState(endDate);

  const [articuloProceso, setArticuloProceso] = useState("");

  const [modalEntradaAlmacen, setModalEntradaAlmacen] = useState(false);
  const toggleEntradaAlmacen = () =>
    setModalEntradaAlmacen(!modalEntradaAlmacen);
  const [articulosCortesEntrada, setArticulosCortesEntrada] = useState([]);
  // Aviso pendiente con el que se prellena la entrada (si lo hay).
  const [avisoEntrada, setAvisoEntrada] = useState(null);
  // Captura del aviso previo del maquilero.
  const [modalAviso, setModalAviso] = useState(false);
  const [avisoCorte, setAvisoCorte] = useState({ id: "", numero: "" });
  const [avisoRenglones, setAvisoRenglones] = useState([]);
  const [avisoPendiente, setAvisoPendiente] = useState(null);
  const [avisoObservaciones, setAvisoObservaciones] = useState("NA");
  const [articulosUnicosEntradaAlma, setArticulosUnicosEntradaAlma] = useState(
    []
  );
  const [codigoSAT, setCodigoSAT] = useState("");
  const [codigoUnidad, setCodigoUnidad] = useState("");
  const [totalPiezasEntradaAlma, setTotalPiezasEntradaAlma] = useState(0);
  const [totalPiezasEntradaSegundasAlma, setTotalPiezasEntradaSegundasAlma] =
    useState(0);
  const [fechaEntradaAlma, setFechaEntradaAlma] = useState(endDate);

  const [PDFPS, setPDFPS] = useState([]);
  const [modalPDFPS, setModalPDFPS] = useState(false);
  const togglePDFPS = () => setModalPDFPS(!modalPDFPS);

  const [PDFPE, setPDFPE] = useState([]);
  const [modalPDFPE, setModalPDFPE] = useState(false);
  const togglePDFPE = () => setModalPDFPE(!modalPDFPE);

  const [modalHabilitacion, setModalHabilitacion] = useState(false);
  const toggleHabilitacion = () => setModalHabilitacion(!modalHabilitacion);
  const [idProcesosSalidaHab, setIdProcesosSalidaHab] = useState("");
  const [idCorteMaquilero, setIdCorteMaquilero] = useState("");
  const [idCorteHab, setIdCorteHab] = useState("");
  const [idPedidoHab, setIdPedidoHab] = useState("");
  const [idProveedorHab, setIdProveedorHab] = useState("");
  const [fechaHab, setFechaHab] = useState("");
  // Editar todo lo de la Orden de Produccion (PDF) de una orden de maquila.
  const [ordenEditar, setOrdenEditar] = useState(null);
  const [recargarListado, setRecargarListado] = useState(0);
  const ordenTallas = [
    "XCH",
    "CH",
    "M",
    "G",
    "XG",
    "7",
    "9",
    "11",
    "13",
  ];

  const [foto, setFoto] = useState("");

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      colores: "",
      tallas: "",
      cantidad: 0,
      cantidadOriginal: 0,
      faltantes: 0,
      segundas: 0,
      total: 0,
      articulosPedido: ""
    },
  ]);

  const [filtroTipoHab, setFiltroTipoHab] = useState("");
  const [inputFieldsHabilitacion, setInputFieldsHabilitacion] = useState([
    {
      id: uuidv4(),
      idHabilitacion: "",
      cantidad: 0
    },
  ]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_CORTES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allCortes = response.data;
        // Array para pagination
        let arrayTabla = allCortes
          .sort((a, b) => (a.idCorte > b.idCorte ? 1 : -1))
          .map((a) => {
          const inactivo = a.is_active === "No";
          // La orden de maquila cuelga directo del pedido. Las historicas
          // tambien guardan su pedido; el camino por la orden de produccion
          // queda solo de respaldo.
          const pedido = a.pedidos?.[0]?.idPedido !== undefined
            ? a.pedidos[0]
            : a.ordenesCorte?.[0]?.pedidos?.[0];
          const articulo = a.articulos?.[0]?.descripcion !== undefined
            ? a.articulos[0]
            : pedido?.articulos?.[0];
            return {
              _id: a._id,
              numero: a.idCorte,
              // Folio con el que la manejan; las ordenes viejas no lo traen.
              folioCAV: a.folioCAV || String(a.idCorte),
              fecha: a.fecha,
              total_cantidad: inactivo ? 0 : a.total_cantidad,
              // Antes era el numero de la orden de produccion; esa capa ya no
              // existe, asi que la columna muestra el pedido.
              ordenCorte: String(pedido?.idPedido ?? ""),
              fechaCancelacionPedido: pedido?.fecha_cancelacion,
              cliente: pedido?.clientes?.[0]?.nombre_comercial ?? "",
              // Compradora del cliente que capturaron en el pedido.
              comprador: pedido?.compradores?.[0]?.name ?? "",
              codigo: articulo?.codigoCliente ?? "",
              articulo: articulo?.descripcion ?? "",
              // Piezas de ESTE articulo en el pedido (puede traer varios).
              cantidadPedido: inactivo ? 0 : a.piezasPedidoArticulo ?? pedido?.total_piezas,
              maquilero:
                a.proveedores && a.proveedores?.[0]
                  ? a.proveedores?.[0]?.nombre_comercial
                  : "Sin asignar",
              idMaquilero:
                a.proveedores && a.proveedores?.[0] ? a.proveedores?.[0]?._id : "",
              fechaCompromiso: a.fechaCompromiso || "",
              precioMaquila: a.precioMaquila || 0,
              recibido: a.resumenEntrega?.recibido ?? 0,
              faltante: a.resumenEntrega?.faltante ?? 0,
              avisoPendiente: a.resumenEntrega?.avisoPendiente ?? null,
              status: a.status,
              observaciones: a.observaciones,
              idArticulo: articulo?._id,
              statusTela: a.statusTela,
              is_active: a.is_active,
              consumoRealPrenda: a.consumoRealPrenda,
              observacionesMaquila: a.observacionesMaquila
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setCortes(allCortes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allAreas = response.data;
        // Solo bodegas: ni los almacenes de maquileros ni Saldos.
        setAreas(allAreas.filter((a) => (a.tipo || "Bodega") === "Bodega"));
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allHabilitacion = response.data;
        // Array para pagination
        let arrayTabla = allHabilitacion
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              nombre: a.nombre,
              unidad: a.unidad,
              observaciones: a.observaciones,
              descripcion: a.descripcion,
              tipo: a.tipo || "",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setHabilitacion(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin, recargarListado]);


  const ListaCortes = comments.sort((a, b) => (a.idCorte < b.idCorte ? 1 : -1));

  function PDFTabla() {
    const data = ListaCortes.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha)
      ) {
        return [a.folioCAV, a.fecha, a.ordenCorte, a.maquilero, a.total_cantidad, a.consumoRealPrenda];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Cortes`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Pedido", "Maquilero", "Cantidad", "Consumo Real Prenda"]],
      body: dataPDFLimpia,
      startY: 45
    });
    // doc.save(`Cortes.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = ListaCortes.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha)
      ) {
        return {
          CAV: a.folioCAV,
          Fecha: a.fecha,
          Pedido: a.ordenCorte,
          Cliente: a.cliente,
          Compradora: a.comprador,
          Codigo: a.codigo,
          Articulo: a.articulo,
          CantidadPedido: a.cantidadPedido,
          CantidadCortada: a.total_cantidad,
          ConsumoRealPrenda: a.consumoRealPrenda
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoCortes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoCortes",
        sheetFilter: ["Numero", "Fecha", "Pedido", "Cliente", "Compradora", "Codigo", "Articulo", "CantidadPedido", "CantidadCortada", "ConsumoRealPrenda"],
        sheetHeader: ["Numero", "Fecha", "Pedido", "Cliente", "Compradora", "Codigo", "Articulo", "CantidadPedido", "CantidadCortada", "ConsumoRealPrenda"]
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaCortes.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha)
      ) {
        return [a.folioCAV, a.fecha, a.ordenCorte, a.maquilero, a.total_cantidad];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Cortes`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Pedido", "Maquilero", "Cantidad"]],
      body: dataPDFLimpia,
      startY: 45
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Cortes",
          email: mailTo,
          fileName: "ListadoCortes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Cortes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`
          }
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Pedido", field: "ordenCorte", sortable: true },
    { name: "CAV", field: "numero", sortable: true },
    { name: "Fecha Creacion", field: "fecha", sortable: true },
    { name: "Maquilero", field: "maquilero", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Compradora", field: "comprador", sortable: true },
    { name: "Codigo", field: "codigo", sortable: false },
    { name: "Articulo", field: "articulo", sortable: false },
    // { name: "Marca", field: "marca", sortable: true },
    {
      name: "Fecha Cancelacion",
      field: "fechaCancelacionPedido",
      sortable: true
    },
    { name: "Cantidad Cortada", field: "total_cantidad", sortable: true },
    { name: "Recibido", field: "recibido", sortable: false },
    { name: "Faltante", field: "faltante", sortable: false },
    { name: "Cantidad Pedido", field: "cantidadPedido", sortable: true },
    { name: "Fecha Compromiso", field: "fechaCompromiso", sortable: true },
    { name: "Precio Maquila", field: "precioMaquila", sortable: true },
    { name: "Consumo Real Prenda", field: "consumoRealPrenda", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Observaciones Maquila", field: "observacionesMaquila", sortable: true },
    { name: "PDF Corte", field: "PDF", sortable: false },
    { name: "Entrada Almacen", field: "Entrada Almacen", sortable: false },
    { name: "Status", field: "status", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.cliente ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.comprador ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.ordenCorte ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.articulo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.observaciones ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.observacionesMaquila ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.folioCAV ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.total_cantidad ?? "").includes(search) ||
          String(comment.cantidadPedido ?? "").includes(search) ||
          String(comment.consumoRealPrenda ?? "").includes(search) ||
          String(comment.maquilero ?? "").toLowerCase().includes(search.toLowerCase())
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "numero" &&
      sorting.field != "total_cantidad" &&
      sorting.field != "cantidadPedido" &&
      sorting.field != "ordenCorte" &&
      sorting.field != "consunmoRealPrenda" &&
      sorting.field != "precioMaquila"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "cantidadPedido" ||
        sorting.field == "ordenCorte" ||
        sorting.field == "consunmoRealPrenda" ||
        sorting.field == "numero" ||
        sorting.field == "precioMaquila")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "cantidadPedido" ||
        sorting.field == "ordenCorte" ||
        sorting.field == "consunmoRealPrenda" ||
        sorting.field == "numero" ||
        sorting.field == "precioMaquila")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  /**
   * PDF "Orden de Produccion": mismo formato que la hoja de Excel (encabezado,
   * piezas por color y talla, habilitacion para maquila y empaque, imagenes del
   * articulo y de la habilitacion, firmas). Los datos y las fotos los arma el
   * back en GET /cortes/:id/ficha.
   */
  async function PDFOC(numero, fecha, ordenCorte, maquilero, total_cantidad, idPDFOC) {
    setModalProgreso(true);
    try {
      const { data } = await axios.get(`${URL_CORTES}/${idPDFOC}/ficha`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      const elaboradoPor = [user.nombre, user.apellido].filter(Boolean).join(" ");
      const doc = await pdfOrdenProduccion(data, { elaboradoPor });
      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "No se pudo generar el PDF",
        text: (err.response && err.response.data && err.response.data.message) || err.message,
      });
    } finally {
      setModalProgreso(false);
    }
  }

  function procesosSalida(id, numero) {
    setEntregaHabilitacion(false);
    setInputFieldsHabilitacion([
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0
      },
    ]);
    axios
      .get(`${URL_ARTICULOS_CORTES}/corte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            return {
              id: a._id,
              articuloNombre:
                (renglonPedido(a)?.articulos?.[0]
                  ?.codigoCliente ?? "") +
                " " +
                (renglonPedido(a)?.articulos?.[0]
                  ?.codigo ?? "") +
                " " +
                (renglonPedido(a)?.articulos?.[0]
                  ?.descripcion ?? ""),
              idArticulo:
                renglonPedido(a)?.articulos?.[0]?._id,
              total_cantidad: a.total_cantidad,
              catalogoProcesos:
                renglonPedido(a)?.articulos?.[0]
                  ?.catalogoProcesos,
              idPedido: a.pedidos?.[0]?._id,
              numeroPedido: a.pedidos?.[0]?.idPedido,
              articulosPedido:
                renglonPedido(a)?._id,
                fechaCancelacion: a.pedidos?.[0]?.fecha_cancelacion
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setArticulosCortes(data);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            total_cantidad: 0
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].idPedido = item.idPedido;
          groups[val].numeroPedido = item.numeroPedido;
          groups[val].articuloNombre = item.articuloNombre;
          groups[val].total_cantidad += item.total_cantidad;
          groups[val].catalogoProcesos = item.catalogoProcesos;
          groups[val].fechaCancelacion = item.fechaCancelacion;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicos(dataFinalAgru);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedCorte(id);
    setSelectedCorteNumero(numero);
    toggleProcesosSalida();
  }

  function funcionProcesosSalida(
    idCatalogoProcesos,
    nombreProcesosSalida,
    idArticulo,
    nombreArticulo,
    idPedido,
    numeroPedido,
    fechaCancelacion
  ) {
    setArticuloProceso(idArticulo);
    axios
      .get(`${URL_ARTICULOS_CORTES}/corte/${selectedCorte}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allArticulosProcesosSalida = response.data;
        setArticulosProcesosSalida(allArticulosProcesosSalida);

        let arrayInputFields = allArticulosProcesosSalida
          .map((a) => {
            if (
              idArticulo ==
              renglonPedido(a)?.articulos?.[0]?._id
            ) {
              return {
                id: uuidv4(),
                colores:
                  renglonPedido(a)?.colores?.[0]?.name,
                tallas:
                  renglonPedido(a)?.tallas?.[0]?.name,
                cantidad: a.total_cantidad,
                cantidadOriginal: a.total_cantidad,
                faltantes: 0,
                segundas: 0,
                total: 0,
                articulosPedido:
                  renglonPedido(a)?._id
              };
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataIF = Object.values(arrayInputFields);

        setInputFields(dataIF);

        let cantTotal = dataIF.map((c) => parseFloat(c.cantidad));
        let TC = cantTotal.reduce((t, total, index) => t + total, 0);
        setTotalPiezas(TC);
      })
      .catch((err) => {
        console.log(err);
      });

    setIdCatalogoProcesos(idCatalogoProcesos);
    setNombreProcesosSalida(nombreProcesosSalida);
    setIdArticulo(idArticulo);
    setNombreArticulo(nombreArticulo);
    setIdPedido(idPedido);
    setNumeroPedido(numeroPedido);
    setFechaCancelacion(fechaCancelacion);
    setModalProcesosSalida(false);
    toggleFuncionProcesosSalida();
  }

  const handleChangeInputPrecio = (event) => {
    const newInputFields = inputFields.map((i) => {
      // i[event.target.name] = event.target.value;
      i.total = i.cantidad * event.target.value;
      return i;
    });
    setPrecioProceso(event.target.value);
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.total = parseFloat(event.target.value) * parseFloat(precioProceso);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidadPS = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        const newValue = parseFloat(event.target.value);
  
        // Validar si la cantidad ingresada es mayor que la cantidad original
        if (newValue > i.cantidadOriginal) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La Cantidad no puede ser mayor a la Cantidad Original!"
          }).then(() => {
            // Restablecer la cantidad a la cantidad original y calcular el total
            i[event.target.name] = i.cantidadOriginal;
            i.total = i.cantidadOriginal * parseFloat(precioProceso);
            setInputFields([...newInputFields]); // Actualizar el estado con la cantidad restablecida
            ActualizaTotales(); // Actualizar los totales después de restablecer
          });
        } else {
          // Actualizar normalmente si la cantidad ingresada es válida
          i[event.target.name] = newValue;
          i.total = newValue * parseFloat(precioProceso);
        }
      }
      return i;
    });
  
    // Actualizar el estado solo si no hubo errores
    setInputFields(newInputFields);
    ActualizaTotales();
  };
  

  const handleChangeInputCantidadFDS = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cantTotal = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cantTotal.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TC);

    let cantTotalFaltantes = inputFields.map((c) => parseFloat(c.faltantes));
    let TF = cantTotalFaltantes.reduce((t, total, index) => t + total, 0);
    setTotalPiezasFaltantes(TF);

    let cantTotalSegundas = inputFields.map((c) => parseFloat(c.segundas));
    let TS = cantTotalSegundas.reduce((t, total, index) => t + total, 0);
    setTotalPiezasSegundas(TS);

    let impTotal = inputFields.map((c) => parseFloat(c.total));
    let TG = impTotal.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  }

  const saveSalidaProceso = async (event) => {
    event.preventDefault();
    if (fechaProceso != "" && fechaCompromisoProceso != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = 0;
      if (entregaHabilitacion) {
        totalRollos = inputFields.length + inputFieldsHabilitacion.length;
      } else {
        totalRollos = inputFields.length;
      }
      try {
        await axios
          .post(
            URL_PROCESOS_SALIDA,
            {
              catalogoProcesos: idCatalogoProcesos,
              proveedores: maquileroProceso,
              pedidos: idPedido,
              fecha: fechaProceso,
              fechaCompromiso: fechaCompromisoProceso,
              observaciones,
              status: "Abierto",
              totalGeneral,
              totalPiezas,
              precio: precioProceso,
              cortes: selectedCorte,
              articulos: articuloProceso
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`
              }
            }
          )
          .then((data) => {
            inputFields.map((a) => {
              if (a.cantidad != 0) {
                axios
                  .post(
                    URL_ARTICULOS_PROCESOS_SALIDA,
                    {
                      procesosSalida: data.data._id,
                      articulosPedido: a.articulosPedido,
                      pedidos: idPedido,
                      cantidadSalida: a.cantidad,
                      cantidadEntrada: 0,
                      faltantes: a.cantidad,
                      cortes: selectedCorte
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`
                      }
                    }
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Salida de Proceso",
                            detalle: `Pedido ${numeroPedido} Articulo ${articulosCortes?.[0]?.articuloNombre}`,
                            user: user.id
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`
                            }
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Salida de Proceso",
                        detalle: `Pedido ${numeroPedido} Articulo ${articulosCortes?.[0]?.articuloNombre}`,
                        user: user.id
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`
                        }
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`
            });
            console.log(error);
            setValidaBoton(true);
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`
      });
    }
  };

  //Procesos Entrada

  function procesosEntrada(id, numero) {
    axios
      .get(`${URL_ARTICULOS_PROCESOS_SALIDA}/corte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            return {
              id: a._id,
              articuloNombre:
                (a.articulosPedido?.[0]?.articulos?.[0]?.codigoCliente ?? "") +
                " " +
                (a.articulosPedido?.[0]?.articulos?.[0]?.codigo ?? "") +
                " " +
                (a.articulosPedido?.[0]?.articulos?.[0]?.descripcion ?? ""),
              idArticulo: a.articulosPedido?.[0]?.articulos?.[0]?._id,
              catalogoProcesos: a.procesosSalida?.[0]?.catalogoProcesos?.[0]?.name,
              idCatalogoProcesos: a.procesosSalida?.[0]?.catalogoProcesos?.[0]?._id,
              idPedido: a.pedidos?.[0]?._id,
              numeroPedido: a.pedidos?.[0]?.idPedido,
              articulosPedido: a.articulosPedido?.[0]?._id,
              cantidadEntrada: a.cantidadEntrada,
              cantidadSalida: a.cantidadSalida,
              status: a.procesosSalida?.[0]?.status,
              fecha: a.procesosSalida?.[0]?.fecha,
              fechaCompromiso: a.procesosSalida?.[0]?.fechaCompromiso,
              precio: a.procesosSalida?.[0]?.precio,
              maquilero: a.procesosSalida?.[0]?.proveedores?.[0]?.nombre_comercial,
              idMaquilero: a.procesosSalida?.[0]?.proveedores?.[0]?._id,
              procesosSalida: a.procesosSalida?.[0]?._id,
              faltantes: a.faltantes,
              faltantesHab: a.faltantesHab,
              segundas: a.segundas
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setArticulosEntrada(data);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["idArticulo"] + item["procesosSalida"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            procesosSalida: item.procesosSalida,
            cantidadSalida: 0,
            cantidadEntrada: 0,
            faltantes: 0,
            faltantesHab: 0,
            segundas: 0
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].idPedido = item.idPedido;
          groups[val].numeroPedido = item.numeroPedido;
          groups[val].articuloNombre = item.articuloNombre;
          groups[val].cantidadSalida += item.cantidadSalida;
          groups[val].cantidadEntrada += item.cantidadEntrada;
          groups[val].catalogoProcesos = item.catalogoProcesos;
          groups[val].idCatalogoProcesos = item.idCatalogoProcesos;
          groups[val].status = item.status;
          groups[val].fecha = item.fecha;
          groups[val].fechaCompromiso = item.fechaCompromiso;
          groups[val].precio = item.precio;
          groups[val].maquilero = item.maquilero;
          groups[val].idMaquilero = item.idMaquilero;
          groups[val].procesosSalida = item.procesosSalida;
          groups[val].faltantes += item.faltantes;
          groups[val].faltantesHab += item.faltantesHab;
          groups[val].segundas += item.segundas;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicosEntrada(dataFinalAgru);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedCorte(id);
    setSelectedCorteNumero(numero);
    toggleProcesosEntrada();
  }

  function funcionProcesosEntrada(
    idCatalogoProcesos,
    nombreProcesosEntrada,
    idArticulo,
    nombreArticulo,
    idPedido,
    numeroPedido,
    procesosSalida
  ) {
    setArticuloProceso(idArticulo);
    axios
      .get(`${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${procesosSalida}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allArticulosProcesosEntrada = response.data;
        setArticulosProcesosEntrada(allArticulosProcesosEntrada);
        setMaquileroProceso(
          allArticulosProcesosEntrada?.[0]?.procesosSalida?.[0]?.proveedores?.[0]?._id
        );
        setPrecioProceso(
          allArticulosProcesosEntrada?.[0]?.procesosSalida?.[0]?.precio
        );

        let arrayInputFields = allArticulosProcesosEntrada.map((a) => {
          return {
            id: uuidv4(),
            colores: a.articulosPedido?.[0]?.colores?.[0]?.name,
            tallas: a.articulosPedido?.[0]?.tallas?.[0]?.name,
            cantidad: a.faltantes,
            faltantes: 0,
            segundas: 0,
            total:
              parseFloat(a.faltantes) * parseFloat(a.procesosSalida?.[0]?.precio),
            articulosPedido: a.articulosPedido?.[0]?._id,
            articulosProcesosSalida: a._id
          };
        });

        let dataIF = Object.values(arrayInputFields);

        setInputFields(dataIF);

        let cantTotal = dataIF.map((c) => parseFloat(c.cantidad));
        let TC = cantTotal.reduce((t, total, index) => t + total, 0);
        setTotalPiezas(TC);

        let impTotal = dataIF.map((c) => parseFloat(c.total));
        let TG = impTotal.reduce((t, total, index) => t + total, 0);
        setTotalGeneral(TG);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedProcesoSalida(procesosSalida);
    setIdCatalogoProcesos(idCatalogoProcesos);
    setNombreProcesosEntrada(nombreProcesosEntrada);
    setIdArticulo(idArticulo);
    setNombreArticulo(nombreArticulo);
    setIdPedido(idPedido);
    setNumeroPedido(numeroPedido);
    setModalProcesosEntrada(false);
    toggleFuncionProcesosEntrada();
  }

  const saveEntradaProceso = async (event) => {
    event.preventDefault();
    if (fechaProceso != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = inputFields.length;
      try {
        await axios
          .post(
            URL_PROCESOS_ENTRADA,
            {
              catalogoProcesos: idCatalogoProcesos,
              proveedores: maquileroProceso,
              pedidos: idPedido,
              fecha: fechaProceso,
              observaciones,
              totalGeneral,
              totalPiezas,
              totalPiezasFaltantes,
              totalPiezasSegundas,
              precio: precioProceso,
              cortes: selectedCorte,
              procesosSalida: selectedProcesoSalida,
              articulos: articuloProceso
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`
              }
            }
          )
          .then((data) => {
            axios.post(
              URL_NOTAS_CXP,
              {
                procesosEntrada: data.data._id,
                proveedores: maquileroProceso,
                total_cantidad: totalPiezas,
                total_costo: totalGeneral,
                saldo: totalGeneral,
                fecha: fechaProceso
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`
                }
              }
            );

            inputFields.map((a) => {
              if (a.cantidad != 0 || a.faltantes != 0 || a.segundas != 0) {
                axios
                  .post(
                    URL_ARTICULOS_PROCESOS_ENTRADA,
                    {
                      procesosEntrada: data.data._id,
                      articulosPedido: a.articulosPedido,
                      articulosProcesosSalida: a.articulosProcesosSalida,
                      pedidos: idPedido,
                      cantidadEntrada: a.cantidad,
                      cantidadFaltantes: a.faltantes,
                      cantidadSegundas: a.segundas,
                      cortes: selectedCorte
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`
                      }
                    }
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Entrada de Proceso",
                            detalle: `Pedido ${numeroPedido}`,
                            user: user.id
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`
                            }
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Entrada de Proceso",
                        detalle: `Pedido ${numeroPedido}`,
                        user: user.id
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`
                        }
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`
      });
    }
  };
  function observacionesEditar(
    id,
    observaciones,
    statusTela
  ) {
    setIdEdit(id);
    setObservacionesEdit(observaciones);
    setStatusTelaEdit(statusTela);
    toggleObservacionesEdit();
  }
  function saveObservacionesEdit(event) {
    event.preventDefault();
    axios
    .patch(
      `${URL_CORTES}/${idEdit}`,
      {
        observaciones: observacionesEdit,
        statusTela: statusTelaEdit
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      }
    )
    .then((response) => {
      axios
        .post(
          URL_LOGS,
          {
            tipo: "Editar Observaciones",
            detalle: `Corte ${idEdit}`,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`
            }
          }
        )
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Listo",
            showConfirmButton: false,
            timer: 2000
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`
          });
          console.log(error);
        });
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`
      });
      console.log(error);
    });
  }

    function observacionesMaquilaEditar(
    id,
    observaciones,
  ) {
    setIdEdit(id);
    setObservacionesMaquilaEdit(observaciones);
    toggleObservacionesMaquilaEdit();
  }
  function saveObservacionesMaquilaEdit(event) {
    event.preventDefault();
    axios
    .patch(
      `${URL_CORTES}/${idEdit}`,
      {
        observacionesMaquila: observacionesMaquilaEdit
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      }
    )
    .then((response) => {
      axios
        .post(
          URL_LOGS,
          {
            tipo: "Editar Observaciones",
            detalle: `Corte ${idEdit}`,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`
            }
          }
        )
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Listo",
            showConfirmButton: false,
            timer: 2000
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`
          });
          console.log(error);
        });
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`
      });
      console.log(error);
    });
  }


  function maquileroEdit(
    id,
    idProveedor,
    precio,
    fechaCompromiso,
    fecha,
    observaciones,
    idCorte
  ) {
    setIdProcesosSalidaHab(id);
    setIdCorteMaquilero(idCorte);
    setSelectedProveedor(idProveedor);
    setPrecioEdit(precio);
    setFechaCompromisoEdit(fechaCompromiso);
    setFechaEdit(fecha);
    setObservacionesEditProceso(observaciones)
    toggleMaquileroEdit();
  }
  function saveMaquileroEdit(event) {
    event.preventDefault();
    axios
    .patch(
      `${URL_PROCESOS_SALIDA}/${idProcesosSalidaHab}`,
      {
        proveedores: selectedProveedor,
        precio: precioEdit,
        fechaCompromiso: fechaCompromisoEdit,
        fecha: fechaEdit,
        observaciones: observacionesEditProceso
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      }
    )
    .then((response) => {
      if (idCorteMaquilero) {
        axios.patch(
          `${URL_CORTES}/${idCorteMaquilero}`,
          { proveedores: selectedProveedor },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`
            }
          }
        );
      }
      axios
        .post(
          URL_LOGS,
          {
            tipo: "Editar Proveedor",
            detalle: `Proceso ${idProcesosSalidaHab} / Orden ${idCorteMaquilero}`,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`
            }
          }
        )
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Listo",
            showConfirmButton: false,
            timer: 2000
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`
          });
          console.log(error);
        });
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`
      });
      console.log(error);
    });
  }
  function jalaHabilitacion(
    id,
    idArticulo,
    numero,
    catalogosProcesosName,
    proveedoresName,
    idProveedor,
    pedido,
    idPedido,
    fechaCompromiso,
    totalPiezas,
    precio,
    totalGeneral,
    fecha,
    idCorte,
    numeroCorte
  ) {
    setIdProcesosSalidaHab(id);
    setIdCorteHab(idCorte);
    setIdPedidoHab(idPedido);
    setIdProveedorHab(idProveedor);

    axios
    .get(`${URL_EXPLOSION}Articulo/${idArticulo}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`
      }
    })
    .then((response) => {
      let allArticulosOrdenCorte = response.data;
      let arrayTabla = allArticulosOrdenCorte
        .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
        .filter((a) => a.cantidad > 0)
        .map((a) => {
          return {
            id: uuidv4(),
            idHabilitacion: a.habilitacion?.[0]?._id,
            // nombre: (a.habilitacion?.[0]?.nombre ?? "") + " " + (a.habilitacion?.[0]?.descripcion ?? ""),
            // cantidadAnterior: a.cantidad,
            cantidad: 0
          }
        })
        .filter(function (el) {
          return el != null;
        });

      const data = Object.values(arrayTabla);
      setInputFieldsHabilitacion(data);
    })
    .catch((err) => {
      console.log(err);
    });



    toggleHabilitacion();
  }

  function saveHabilitacion(event) {
    event.preventDefault();
    let totalRollos = inputFieldsHabilitacion.length;
    axios
      .post(
        URL_HABILITACION_CORTES,
        {
          cortes: idCorteHab,
          pedidos: idPedidoHab,
          proveedores: idProveedorHab,
          procesosSalida: idProcesosSalidaHab,
          fecha: fechaHab
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`
          }
        }
      )
      .then((data2) => {
        inputFieldsHabilitacion.map((a) => {
          if (a.cantidad != 0) {
            axios
              .post(
                URL_DETALLE_HABILITACION_CORTES,
                {
                  cantidad: a.cantidad,
                  habilitacionCortes: data2.data._id,
                  cortes: idCorteHab,
                  pedidos: idPedidoHab,
                  proveedores: idProveedorHab,
                  procesosSalida: idProcesosSalidaHab,
                  habilitacion: a.idHabilitacion
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`
                  }
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Salida de Habilitacion",
                        detalle: `Pedido ${idPedidoHab}`,
                        user: user.id
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`
                        }
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
          } else {
            totalRollos = totalRollos - 1;
            if (totalRollos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Salida de Habilitacion",
                    detalle: `Pedido ${idPedidoHab}`,
                    user: user.id
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`
                    }
                  }
                )
                .then(() => {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  const handleChangeInputHabilitacion = (id, event) => {
    const newInputFieldsHabilitacion = inputFieldsHabilitacion.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsHabilitacion(newInputFieldsHabilitacion);
  };

  const handleRemoveFieldsHabilitaccion = (id) => {
    const values = [...inputFieldsHabilitacion];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsHabilitacion(values);
  };

  const handleAddFieldsHabilitacion = () => {
    setInputFieldsHabilitacion([
      ...inputFieldsHabilitacion,
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0
      },
    ]);
  };
  function cerrarProcesosEntrada(
    procesosSalida,
    faltantes,
    faltantesHab,
    maquilero
  ) {
    if (faltantes > 0 || faltantesHab > 0) {
      setCantidadFaltante(faltantes);
      setCantidadFaltanteHab(faltantesHab);
      setProcesoSalidaFaltante(procesosSalida);
      setIdMaquileroFaltante(maquilero);
      setTotalFaltante(0);
      toggleFaltante();
    } else {
      Swal.fire({
        title: "Estas seguro?",
        text: "Se cerrara el proceso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, cerrar!"
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .patch(
              `${URL_PROCESOS_SALIDA}/${procesosSalida}`,
              {
                status: "Cerrado"
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`
                }
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Cerrar Proceso",
                    detalle: `Proceso ${procesosSalida}`,
                    user: user.id
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`
                    }
                  }
                )
                .then(() => {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Se cerro",
                    showConfirmButton: false,
                    timer: 2000
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`
              });
              console.log(error);
            });
        }
      });
    }
  }

  function saveFaltantes(event) {
    event.preventDefault();
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cerrara el proceso!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, cerrar!"
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_PROCESOS_SALIDA}/${procesoSalidaFaltante}`,
            {
              status: "Cerrado"
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`
              }
            }
          )
          .then(() => {
            axios
              .post(
                URL_FALTANTES_PROVEEDORES,
                {
                  fecha: fechaFaltante,
                  procesosSalida: procesoSalidaFaltante,
                  cantidadFal: cantidadFaltante,
                  precioFal: precioFaltante,
                  totalFal: totalFaltante,
                  cantidadHab: cantidadFaltanteHab,
                  precioHab: precioFaltanteHab,
                  totalHab: totalFaltanteHab,
                  total: totalTotalFaltante,
                  proveedores: idMaquileroFaltante,
                  utilizado: 0,
                  saldo: totalTotalFaltante
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`
                  }
                }
              )
              .then(() => {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Cerrar Proceso",
                      detalle: `Proceso ${procesoSalidaFaltante}`,
                      user: user.id
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`
                      }
                    }
                  )
                  .then(() => {
                    Swal.fire({
                      position: "center",
                      icon: "success",
                      title: "Se cerro",
                      showConfirmButton: false,
                      timer: 2000
                    });
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`
                    });
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`
            });
            console.log(error);
          });
      }
    });
  }

  function entradaAlmacen(id, numero) {
    const cab = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    Promise.all([
      axios.get(`${URL_ARTICULOS_CORTES}/corte/${id}`, cab),
      // Si el aviso falla no se bloquea la entrada: se abre sin prellenar.
      axios.get(`${URL_AVISOS_ENTREGA}/corte/${id}`, cab).catch(() => ({ data: [] })),
    ])
      .then(([response, respAvisos]) => {
        // Con aviso pendiente, la entrada se prellena con lo avisado; sin el,
        // con lo que falta por recibir.
        const aviso = (respAvisos.data || []).find((x) => x.status === "Pendiente") || null;
        setAvisoEntrada(aviso);
        const delAviso = new Map((aviso?.renglones || []).map((r) => [String(r.articulosCortes), r]));
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            return {
              id: a._id,
              articuloNombre:
                (renglonPedido(a)?.articulos?.[0]
                  ?.codigoCliente ?? "") +
                " " +
                (renglonPedido(a)?.articulos?.[0]
                  ?.codigo ?? "") +
                " " +
                (renglonPedido(a)?.articulos?.[0]
                  ?.descripcion ?? ""),
              idArticulo:
                renglonPedido(a)?.articulos?.[0]?._id,
              mandado: a.total_cantidad || 0,
              faltante: Math.max(0, a.faltanteRecibir || 0),
              cantidad: aviso
                ? delAviso.get(String(a._id))?.cantidad ?? 0
                : Math.max(0, a.faltanteRecibir || 0),
              segundas: aviso ? delAviso.get(String(a._id))?.segundas ?? 0 : 0,
              catalogoProcesos:
                renglonPedido(a)?.articulos?.[0]
                  ?.catalogoProcesos,
              idTalla:
                renglonPedido(a)?.tallas?.[0]?._id,
              talla:
                renglonPedido(a)?.tallas?.[0]?.name,
              idColor:
                renglonPedido(a)?.colores?.[0]?._id,
              color:
                renglonPedido(a)?.colores?.[0]?.name
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setArticulosCortesEntrada(data);
        setIdArticulo(data?.[0]?.idArticulo);
        let cantTotal = data.map((c) => parseFloat(c.cantidad));
        let TC = cantTotal.reduce((t, total, index) => t + total, 0);
        setTotalPiezasEntradaAlma(TC);

        let cantTotalSeg = data.map((c) => parseFloat(c.segundas));
        let TCSeg = cantTotalSeg.reduce((t, total, index) => t + total, 0);
        setTotalPiezasEntradaSegundasAlma(TCSeg);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo
          };
          groups[val].idArticulo = item.idArticulo;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicosEntradaAlma(dataFinalAgru);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedCorte(id);
    setSelectedCorteNumero(numero);
    toggleEntradaAlmacen();
  }

  // ---------------- Aviso previo del maquilero ----------------
  // Lo que el maquilero avisa que va a entregar. No mueve inventario: la
  // Entrada al Almacen se abre prellenada con esto.
  function abrirAviso(id, numero) {
    const cab = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    setAvisoCorte({ id, numero });
    setAvisoObservaciones("NA");
    Promise.all([
      axios.get(`${URL_ARTICULOS_CORTES}/corte/${id}`, cab),
      axios.get(`${URL_AVISOS_ENTREGA}/corte/${id}`, cab),
    ])
      .then(([resRenglones, resAvisos]) => {
        setAvisoPendiente((resAvisos.data || []).find((x) => x.status === "Pendiente") || null);
        setAvisoRenglones(
          resRenglones.data
            .filter((a) => a.is_active !== "No")
            .map((a) => ({
              id: a._id,
              talla: renglonPedido(a)?.tallas?.[0]?.name ?? "",
              color: renglonPedido(a)?.colores?.[0]?.name ?? "",
              mandado: a.total_cantidad || 0,
              faltante: Math.max(0, a.faltanteRecibir || 0),
              // Se propone lo que falta; el usuario lo baja a lo que avisa el maquilero.
              cantidad: Math.max(0, a.faltanteRecibir || 0),
              segundas: 0,
            }))
            .sort((x, y) => (x.color + x.talla > y.color + y.talla ? 1 : -1))
        );
        setModalAviso(true);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({ icon: "error", title: "No se pudo abrir el aviso", text: err.response?.data?.message || err.message });
      });
  }

  const cambiaAviso = (id, campo, valor) => {
    const n = parseFloat(valor);
    setAvisoRenglones((previos) =>
      previos.map((r) => (r.id === id ? { ...r, [campo]: isNaN(n) || n < 0 ? 0 : n } : r))
    );
  };

  async function guardarAviso() {
    const cab = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    const renglones = avisoRenglones
      .filter((r) => r.cantidad + r.segundas > 0)
      .map((r) => ({ articulosCortes: r.id, cantidad: r.cantidad, segundas: r.segundas }));
    if (!renglones.length) {
      return Swal.fire({ icon: "warning", title: "El aviso no trae piezas" });
    }
    try {
      const { data } = await axios.post(
        URL_AVISOS_ENTREGA,
        { cortes: avisoCorte.id, fecha: moment().format("YYYY-MM-DD"), observaciones: avisoObservaciones, renglones },
        cab
      );
      setModalAviso(false);
      await Swal.fire({
        icon: "success",
        title: `Aviso ${data.idAvisoEntrega} registrado`,
        text: `${data.total} pzas. La entrada al almacen se abrira con estas cantidades.`,
      });
      window.location.reload();
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se pudo guardar el aviso", text: error.response?.data?.message || error.message });
    }
  }

  async function cancelarAviso() {
    const cab = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    const ok = await Swal.fire({
      icon: "warning",
      title: `Cancelar el aviso ${avisoPendiente.idAvisoEntrega}?`,
      text: "Usalo si el maquilero no va a entregar lo que aviso.",
      showCancelButton: true,
      confirmButtonText: "Si, cancelar",
      cancelButtonText: "No",
    });
    if (!ok.value) return;
    try {
      await axios.patch(`${URL_AVISOS_ENTREGA}/${avisoPendiente._id}/cancelar`, {}, cab);
      setAvisoPendiente(null);
      Swal.fire({ icon: "success", title: "Aviso cancelado" });
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se pudo cancelar", text: error.response?.data?.message || error.message });
    }
  }

  const handleChangeInputCantidadEntradaAlma = (id, event) => {
    const newArticulosCortesEntrada = articulosCortesEntrada.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setArticulosCortesEntrada(newArticulosCortesEntrada);
    ActualizaTotalesEntradaAlma();
  };

  const handleChangeInputEntradaSegundasAlma = (id, event) => {
    const newArticulosCortesEntrada = articulosCortesEntrada.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setArticulosCortesEntrada(newArticulosCortesEntrada);
    ActualizaTotalesEntradaAlma();
  };

function ActualizaTotalesEntradaAlma() {
    let cantTotal = articulosCortesEntrada.map((c) => parseFloat(c.cantidad));
    let TC = cantTotal.reduce((t, total, index) => t + total, 0);
    setTotalPiezasEntradaAlma(TC);

    let cantTotalSeg = articulosCortesEntrada.map((c) =>
      parseFloat(c.segundas)
    );
    let TCSeg = cantTotalSeg.reduce((t, total, index) => t + total, 0);
    setTotalPiezasEntradaSegundasAlma(TCSeg);
  }

  /**
   * Registra la Entrada de prenda terminada.
   *
   * Una sola llamada: el back da de alta el producto terminado, descuenta la
   * tela y la habilitacion del almacen del maquilero segun la explosion del
   * pedido, y lo hace todo dentro de una transaccion. Antes esto eran N POST
   * encadenados desde el navegador, y si se cerraba la pestana a media lista
   * quedaban renglones aplicados y otros no.
   */
  const saveEntradaAlma = async (event, sinConsumo = false) => {
    if (event) event.preventDefault();
    if (fechaEntradaAlma === "") {
      return Swal.fire({ icon: "error", title: "Faltan datos", text: "Captura la fecha" });
    }

    const renglones = articulosCortesEntrada
      .filter((a) => parseFloat(a.cantidad) > 0 || parseFloat(a.segundas) > 0)
      .map((a) => ({
        articulosCortes: a.id,
        articulos: a.idArticulo,
        tallas: a.idTalla,
        colores: a.idColor,
        cantidad: parseFloat(a.cantidad) || 0,
        segundas: parseFloat(a.segundas) || 0,
      }));

    if (renglones.length === 0) {
      return Swal.fire({ icon: "warning", title: "Sin piezas", text: "No hay cantidades capturadas" });
    }

    setValidaBoton(false);
    toggleProgreso();
    const cabeceras = {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    };

    try {
      await axios.patch(`${URL_ARTICULOS}/${idArticulo}`, { codigoSAT, codigoUnidad }, cabeceras);

      const { data } = await axios.post(
        URL_ENTRADAS_ALMACEN_COMPLETA,
        {
          fecha: fechaEntradaAlma,
          cortes: selectedCorte,
          areas: areasEntrada,
          articulos: idArticulo,
          observaciones,
          renglones,
          sinConsumo,
          avisosEntrega: avisoEntrada ? avisoEntrada._id : undefined,
        },
        cabeceras
      );

      await axios.post(
        URL_LOGS,
        { tipo: "Entrada Almacen", detalle: `Corte ${selectedCorte}`, user: user.id },
        cabeceras
      );

      const consumo = (data.consumos || [])
        .map((c) => `${c.cantidadTeorica}`)
        .length;
      // La entrada genera la cuenta por pagar al maquilero; si no se pudo
      // (orden sin precio de maquila) el back lo dice en avisoCxP.
      const nota = data.notasCxP;
      const lineaCxP = nota
        ? `<br/>Cuenta por pagar al maquilero: <b>$${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(nota.total_costo)}</b> (${nota.total_cantidad} pzas x $${nota.precioMaquila})`
        : `<br/><span style="color:#b45309">${data.avisoCxP || "No se genero cuenta por pagar"}</span>`;
      await Swal.fire({
        icon: nota ? "success" : "warning",
        title: "Entrada registrada",
        html:
          (consumo
            ? `${data.piezas} pzas · se descontaron ${consumo} material(es) del maquilero`
            : `${data.piezas} pzas · sin descuento de material`) + lineaCxP,
      });
      window.location.reload();
    } catch (error) {
      const info = error.response ? error.response.data : {};
      setValidaBoton(true);
      toggleProgreso();

      // Al maquilero no le alcanza el material: se listan los faltantes.
      if (info.faltantes && info.faltantes.length) {
        return Swal.fire({
          icon: "error",
          title: "Al maquilero no le alcanza el material",
          html: info.faltantes
            .map((f) => `${f.material}${f.color ? ` (${f.color})` : ""}: faltan <b>${f.faltante}</b> (hay ${f.existencia}, se requieren ${f.requerido})`)
            .join("<br/>"),
        });
      }

      // El pedido no tiene explosion: se ofrece registrar sin consumo.
      if (info.sinExplosion) {
        const confirma = await Swal.fire({
          icon: "warning",
          title: "Este pedido no tiene explosion",
          text: "Se puede registrar la entrada sin descontar material y capturar el consumo despues.",
          showCancelButton: true,
          confirmButtonText: "Registrar sin consumo",
          cancelButtonText: "Cancelar",
        });
        if (confirma.isConfirmed) return saveEntradaAlma(null, true);
        return;
      }

      Swal.fire({ icon: "error", title: "No se pudo registrar", text: info.message || "Algo salio mal" });
    }
  };

  // PDF Procesos
  function PDFProcesosSalida(id, numero, observaciones) {
    setEditHab([])
    setObservaciones(observaciones)
    axios
      .get(`${URL_PROCESOS_SALIDA}/corte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
          .map((a) => {
            return {
              id: a._id,
              catalogosProcesosName: a.catalogoProcesos?.[0]?.name,
              proveedoresName: a.proveedores?.[0]?.nombre_comercial,
              idProveedor: a.proveedores?.[0]?._id,
              pedido: a.pedidos?.[0]?.idPedido,
              idPedido: a.pedidos?.[0]?._id,
              fechaCompromiso: a.fechaCompromiso,
              totalGeneral: a.totalGeneral,
              totalPiezas: a.totalPiezas,
              precio: a.precio,
              numero: a.idProcesosSalida,
              fecha: a.fecha,
              idCorte: a.cortes?.[0]?._id,
              numeroCorte: a.cortes?.[0]?.idCorte,
              ordenCorte: String(a.cortes?.[0]?.pedidos?.[0]?.idPedido ?? a.pedidos?.[0]?.idPedido ?? ""),
              articulo:
                (a.articulos?.[0]?.codigo ?? "") + " / " + (a.articulos?.[0]?.codigoCliente ?? ""),
                descripcion: a.articulos?.[0]?.descripcion,
              idArticulo: a.articulos?.[0]?._id,
              cliente: a.pedidos?.[0]?.clientes?.[0]?.nombre_comercial,
              observacionesProceso: a.observaciones
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setPDFPS(data);
      })
      .catch((err) => {
        console.log(err);
      });
    togglePDFPS();
  }

  async function PDFOCPS(
    id,
    numero,
    proceso,
    maquilero,
    pedido,
    fechaCompromiso,
    totalPiezas,
    precio,
    totalGeneral,
    fecha,
    idArticulo,
    descripcion,
    ordenCorte,
    articulo,
    cliente,
    observacionesProceso
  ) {
    var fotoDany;
    await axios
      .get(`${process.env.REACT_APP_URL_GETMEDIA}/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((data) => {
        if (data.data.secure_url != null) {
          fotoDany = data.data.secure_url;
          //  return setFoto(data.data.secure_url)
        } else fotoDany = process.env.PUBLIC_URL + "sinImagen.png";
      })
      .catch((err) => {
        console.log(err);
      });

    await axios
      .get(`${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then(async (response) => {
        let allArticulosCorteCorte = response.data;
        let colorTallaCantidad = {};

        allArticulosCorteCorte.forEach((a) => {
            const color = a.articulosPedido?.[0]?.colores?.[0]?.name;
            const talla = a.articulosPedido?.[0]?.tallas?.[0]?.name;
            const cantidad = a.cantidadSalida;

            if (!colorTallaCantidad[talla]) {
                colorTallaCantidad[talla] = {};
            }
            if (!colorTallaCantidad[talla][color]) {
                colorTallaCantidad[talla][color] = 0;
            }
            colorTallaCantidad[talla][color] += cantidad;
        });

        const tallas = Object.keys(colorTallaCantidad).sort();
        const colores = [
            ...new Set(allArticulosCorteCorte.map((a) => a.articulosPedido?.[0]?.colores?.[0]?.name)),
        ].sort();

        await axios
          .get(`${URL_DETALLE_HABILITACION_CORTES}/proceso/${id}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`
            }
          })
          .then((hab) => {
            let allHabilitacionCorte = hab.data;
            let arrayTablaHab = allHabilitacionCorte
            .sort((a, b) => (a.habilitacion?.[0]?.descripcion > b.habilitacion?.[0]?.descripcion ? 1 : -1))
              .map((a) => {
                if(a.cantidad > 0)
                return [
                  a.habilitacionCortes?.[0]?.fecha,
                  (a.habilitacion?.[0]?.nombre ?? "") +
                    " " +
                    (a.habilitacion?.[0]?.descripcion ?? ""),
                  a.cantidad,
                ];
              })
              .filter(function (el) {
                return el != null;
              });

            const dataPDFHab = Object.values(arrayTablaHab);

            const doc = new jsPDF("landscape");

            var img3 = new Image();
            img3.src = fotoDany;
            doc.addImage(img3, "unknow", 230, 10, 45, 40);

            var img = new Image();
            img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
            doc.addImage(img, "png", 130, 10, 40, 10);
            var img2 = new Image();
            img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
            doc.addImage(img2, "png", 120, 20, 60, 25);
            doc.text(`Maquilero ${maquilero}`, 20, 20);
            doc.setFontSize(12);
            doc.text(`Fecha ${fecha}`, 20, 25);
            doc.text(`Fecha Compromiso ${fechaCompromiso}`, 20, 30);
            doc.text(`Proceso Salida ${proceso}`, 20, 35);
            doc.text(`Cliente ${cliente}`, 20, 40);
            doc.text(`Pedido ${ordenCorte}`, 20, 45);
            doc.text(`Articulo ${articulo} ${descripcion}`, 20, 50);
            doc.text(`Precio $${precio}`, 20, 55);
            doc.text(`Observaciones ${observacionesProceso}`, 20, 60);

            // Crear una variable para almacenar todas las filas de datos
              const bodyData = [];

              // Iterar sobre las tallas
              tallas.forEach((talla) => {
                  let rowData = [talla];
                  let totalTalla = 0;

                  // Iterar sobre los colores
                  colores.forEach((color) => {
                      const cantidad = colorTallaCantidad[talla][color] || 0;
                      rowData.push(cantidad);
                      totalTalla += cantidad;
                  });

                  // Agregar el total por talla al final de la fila
                  rowData.push(totalTalla);

                  // Agregar la fila de datos al conjunto de datos del cuerpo
                  bodyData.push(rowData);
              });

              // Calcular y agregar totales por color en una fila al final de la tabla
              const totalesColorRow = ["Total"];
              let totalGeneral = 0; // Inicializar el total general
              colores.forEach((color) => {
                  let totalColor = 0;
                  tallas.forEach((talla) => {
                      totalColor += colorTallaCantidad[talla][color] || 0;
                  });
                  totalesColorRow.push(totalColor);
                  totalGeneral += totalColor; // Sumar al total general
              });

              // Agregar el total general al final de la fila de totales
              totalesColorRow.push(totalGeneral);

              // Agregar totalesColorRow al final de bodyData
              bodyData.push(totalesColorRow);

              // Generar la tabla con todos los datos del cuerpo y los estilos definidos fuera del bucle
              doc.autoTable({
                  head: [["Tallas", ...colores, "Total"]],
                  body: bodyData, // Utilizar el conjunto de datos del cuerpo
                  startY: 65,
                  styles: {
                      fontSize: 10,
                      cellPadding: 0.7,
                      valign: "middle",
                      halign: "center"
                  }, // Estilos generales de las celdas
                  headStyles: {
                      fillColor: [41, 128, 186],
                      textColor: [255, 255, 255],
                      fontStyle: "bold",
                      halign: "center"
                  }, // Estilos para el encabezado
              });


            doc.text(`Habilitacion`, 15, doc.autoTable.previous.finalY + 10);
            doc.autoTable({
              head: [["Fecha", "Descripcion", "Cantidad"]],
              body: dataPDFHab,
              startY: doc.autoTable.previous.finalY + 13,
              showFoot: "lastPage"
            });
           
            
            doc.setFontSize(10);
            const pageHeight = doc.internal.pageSize.height; // Altura de la página
            const marginBottom = 40; // Margen desde el borde inferior
            const availableSpace = pageHeight - doc.autoTable.previous.finalY - marginBottom;
            
            // Dividimos el texto en líneas ajustadas al ancho de la página
            let nota = `
1) El propósito de realizar el contrato, es tener continuidad de maquileros óptimos para la elaboración de las prendas con excelente calidad y entrega en tiempo y forma, según lo pactado.
2) El MAQUILERO se compromete a entregar bajo las condiciones requeridas por la EMPRESA, el producto a maquilar; REPORTANDO oportunamente (no más de dos días hábiles a partir de la fecha en que se celebra este contrato) faltantes o defectos en habilitación, corte y/o calidad en tela; Asumiendo que, si no se hace dentro de los dos días hábiles siguientes a la entrega de maquila, el maquilero se hará responsable de los gastos que conlleve la reposición de habilitación, tela o cualquier complemento que se requiera para el producto, así con algún reproceso.
3) El MAQUILERO deberá llevarse con el corte a maquilar, la orden de producción, habilitación, hoja de especificaciones y muestra física correspondiente al modelo a maquilar.
4) El MAQUILERO deberá sacar cita previa a la entrega del producto en Almacen de producto terminado, con dos días hábiles de anticipación, tomando en cuenta que los días VIERNES no hay recepción de maquila, a menos que la empresa así lo requiera.
5) El MAQUILERO se compromete a entregar el producto en la fecha y hora pactada junto la orden de producción y hoja de especificaciones para revisión en almacén.
6) El MAQUILERO deberá de llevar a la EMPRESA 2 contra muestras para autorización de confección al departamento correspondiente (calidad y diseño); Ambas en T=CH; De lo contrario se hace acreedor a una multa de $ 500.00 pesos y/o los gastos que se deriven por incumplir esta cláusula.
7) El MAQUILERO tiene como máximo 5 días hábiles, para entregar sus contra muestras antes mencionadas, a partir de la fecha que cargó el corte. No se efectuará ningún tipo de préstamo o pago si no se cumple con la entrega de contra muestras.
8) El MAQUILERO deberá entregar el modelo completo sin ningún tipo de faltantes, ya que éstos se le cobrarán a precio facturado por la empresa; En caso de tener faltantes o piezas incompletas, solicitar reposición del material requerido según sea el caso.
9) LA EMPRESA no aceptará maquilas parciales o incompletos a excepción de que fueran solicitados por la misma.
10) LA EMPRESA está obligada a realizar la entrada del producto inmediatamente y entregar su entrada correspondiente.
11) EL MAQUILERO se compromete a recoger y entregar el producto en el domicilio de LA EMPRESA dentro de la fecha pactada y horario establecido, de lo contrario el MAQUILERO se hace acreedor a un cargo del 25% sobre el precio pactado de maquila.
            `;
            
            let lines3 = doc.splitTextToSize(nota, 260);
            
            // Calculamos la posición inicial para las notas
            let startY = doc.autoTable.previous.finalY + 10;
            
            // Verificamos si hay espacio suficiente para las notas y la firma
            if (startY + lines3.length * 10 + 20 > pageHeight - marginBottom) {
              doc.addPage(); // Agregar una nueva página si es necesario
              startY = 20; // Reiniciar el inicio de las notas
            }
            
            // Renderizamos las notas
            doc.text(15, startY, lines3);
            
            // Ajustamos la posición de la firma
            let firmaStartY = Math.min(pageHeight - marginBottom, startY + lines3.length * 10 + 10);
            
            doc.setFontSize(18);
            doc.text("Maquilero", 142, firmaStartY + 7);
            doc.setFontSize(12);
            doc.text("___________________", 135, firmaStartY + 0);
            
            // Abre el PDF en una nueva pestaña
            window.open(doc.output("bloburl"), "_blank");
            
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function PDFOCPSSinPrecio(
    id,
    numero,
    proceso,
    maquilero,
    pedido,
    fechaCompromiso,
    totalPiezas,
    precio,
    totalGeneral,
    fecha,
    idArticulo,
    descripcion,
    ordenCorte,
    articulo,
    cliente,
    observacionesProceso
  ) {

    var fotoDany;
    await axios
      .get(`${process.env.REACT_APP_URL_GETMEDIA}/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((data) => {
        if (data.data.secure_url != null) {
          fotoDany = data.data.secure_url;
          //  return setFoto(data.data.secure_url)
        } else fotoDany = process.env.PUBLIC_URL + "sinImagen.png";
      })
      .catch((err) => {
        console.log(err);
      });

    await axios
      .get(`${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then(async (response) => {
        let allArticulosCorteCorte = response.data;
        let colorTallaCantidad = {};

        allArticulosCorteCorte.forEach((a) => {
            const color = a.articulosPedido?.[0]?.colores?.[0]?.name;
            const talla = a.articulosPedido?.[0]?.tallas?.[0]?.name;
            const cantidad = a.cantidadSalida;

            if (!colorTallaCantidad[talla]) {
                colorTallaCantidad[talla] = {};
            }
            if (!colorTallaCantidad[talla][color]) {
                colorTallaCantidad[talla][color] = 0;
            }
            colorTallaCantidad[talla][color] += cantidad;
        });

        const tallas = Object.keys(colorTallaCantidad).sort();
        const colores = [
            ...new Set(allArticulosCorteCorte.map((a) => a.articulosPedido?.[0]?.colores?.[0]?.name)),
        ].sort();

        await axios
          .get(`${URL_DETALLE_HABILITACION_CORTES}/proceso/${id}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`
            }
          })
          .then((hab) => {
            let allHabilitacionCorte = hab.data;
            let arrayTablaHab = allHabilitacionCorte
            .sort((a, b) => (a.habilitacion?.[0]?.descripcion > b.habilitacion?.[0]?.descripcion ? 1 : -1))
              .map((a) => {
                if(a.cantidad > 0)
                return [
                  a.habilitacionCortes?.[0]?.fecha,
                  (a.habilitacion?.[0]?.nombre ?? "") +
                    " " +
                    (a.habilitacion?.[0]?.descripcion ?? ""),
                  a.cantidad,
                ];
              })
              .filter(function (el) {
                return el != null;
              });

            const dataPDFHab = Object.values(arrayTablaHab);

            const doc = new jsPDF("landscape");

            var img3 = new Image();
            img3.src = fotoDany;
            doc.addImage(img3, "unknow", 230, 10, 45, 40);

            var img = new Image();
            img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
            doc.addImage(img, "png", 130, 10, 40, 10);
            var img2 = new Image();
            img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
            doc.addImage(img2, "png", 120, 20, 60, 25);
            doc.text(`Maquilero ${maquilero}`, 20, 20);
            doc.setFontSize(12);
            doc.text(`Fecha ${fecha}`, 20, 25);
            doc.text(`Fecha Compromiso ${fechaCompromiso}`, 20, 30);
            doc.text(`Proceso Salida ${proceso}`, 20, 35);
            doc.text(`Cliente ${cliente}`, 20, 40);
            doc.text(`Pedido ${ordenCorte}`, 20, 45);
            doc.text(`Articulo ${articulo} ${descripcion}`, 20, 50);
            // doc.text(`Precio $${precio}`, 20, 55);
            doc.text(`Observaciones ${observacionesProceso}`, 20, 55);

            // Crear una variable para almacenar todas las filas de datos
              const bodyData = [];

              // Iterar sobre las tallas
              tallas.forEach((talla) => {
                  let rowData = [talla];
                  let totalTalla = 0;

                  // Iterar sobre los colores
                  colores.forEach((color) => {
                      const cantidad = colorTallaCantidad[talla][color] || 0;
                      rowData.push(cantidad);
                      totalTalla += cantidad;
                  });

                  // Agregar el total por talla al final de la fila
                  rowData.push(totalTalla);

                  // Agregar la fila de datos al conjunto de datos del cuerpo
                  bodyData.push(rowData);
              });

              // Calcular y agregar totales por color en una fila al final de la tabla
              const totalesColorRow = ["Total"];
              let totalGeneral = 0; // Inicializar el total general
              colores.forEach((color) => {
                  let totalColor = 0;
                  tallas.forEach((talla) => {
                      totalColor += colorTallaCantidad[talla][color] || 0;
                  });
                  totalesColorRow.push(totalColor);
                  totalGeneral += totalColor; // Sumar al total general
              });

              // Agregar el total general al final de la fila de totales
              totalesColorRow.push(totalGeneral);

              // Agregar totalesColorRow al final de bodyData
              bodyData.push(totalesColorRow);

              // Generar la tabla con todos los datos del cuerpo y los estilos definidos fuera del bucle
              doc.autoTable({
                  head: [["Tallas", ...colores, "Total"]],
                  body: bodyData, // Utilizar el conjunto de datos del cuerpo
                  startY: 65,
                  styles: {
                      fontSize: 10,
                      cellPadding: 0.7,
                      valign: "middle",
                      halign: "center"
                  }, // Estilos generales de las celdas
                  headStyles: {
                      fillColor: [41, 128, 186],
                      textColor: [255, 255, 255],
                      fontStyle: "bold",
                      halign: "center"
                  }, // Estilos para el encabezado
              });


            doc.text(`Habilitacion`, 15, doc.autoTable.previous.finalY + 10);
            doc.autoTable({
              head: [["Fecha", "Descripcion", "Cantidad"]],
              body: dataPDFHab,
              startY: doc.autoTable.previous.finalY + 13,
              showFoot: "lastPage"
            });
           
            
            doc.setFontSize(10);
            const pageHeight = doc.internal.pageSize.height; // Altura de la página
            const marginBottom = 40; // Margen desde el borde inferior
            const availableSpace = pageHeight - doc.autoTable.previous.finalY - marginBottom;
            
            // Dividimos el texto en líneas ajustadas al ancho de la página
            let nota = `
1) El propósito de realizar el contrato, es tener continuidad de maquileros óptimos para la elaboración de las prendas con excelente calidad y entrega en tiempo y forma, según lo pactado.
2) El MAQUILERO se compromete a entregar bajo las condiciones requeridas por la EMPRESA, el producto a maquilar; REPORTANDO oportunamente (no más de dos días hábiles a partir de la fecha en que se celebra este contrato) faltantes o defectos en habilitación, corte y/o calidad en tela; Asumiendo que, si no se hace dentro de los dos días hábiles siguientes a la entrega de maquila, el maquilero se hará responsable de los gastos que conlleve la reposición de habilitación, tela o cualquier complemento que se requiera para el producto, así con algún reproceso.
3) El MAQUILERO deberá llevarse con el corte a maquilar, la orden de producción, habilitación, hoja de especificaciones y muestra física correspondiente al modelo a maquilar.
4) El MAQUILERO deberá sacar cita previa a la entrega del producto en Almacen de producto terminado, con dos días hábiles de anticipación, tomando en cuenta que los días VIERNES no hay recepción de maquila, a menos que la empresa así lo requiera.
5) El MAQUILERO se compromete a entregar el producto en la fecha y hora pactada junto la orden de producción y hoja de especificaciones para revisión en almacén.
6) El MAQUILERO deberá de llevar a la EMPRESA 2 contra muestras para autorización de confección al departamento correspondiente (calidad y diseño); Ambas en T=CH; De lo contrario se hace acreedor a una multa de $ 500.00 pesos y/o los gastos que se deriven por incumplir esta cláusula.
7) El MAQUILERO tiene como máximo 5 días hábiles, para entregar sus contra muestras antes mencionadas, a partir de la fecha que cargó el corte. No se efectuará ningún tipo de préstamo o pago si no se cumple con la entrega de contra muestras.
8) El MAQUILERO deberá entregar el modelo completo sin ningún tipo de faltantes, ya que éstos se le cobrarán a precio facturado por la empresa; En caso de tener faltantes o piezas incompletas, solicitar reposición del material requerido según sea el caso.
9) LA EMPRESA no aceptará maquilas parciales o incompletos a excepción de que fueran solicitados por la misma.
10) LA EMPRESA está obligada a realizar la entrada del producto inmediatamente y entregar su entrada correspondiente.
11) EL MAQUILERO se compromete a recoger y entregar el producto en el domicilio de LA EMPRESA dentro de la fecha pactada y horario establecido, de lo contrario el MAQUILERO se hace acreedor a un cargo del 25% sobre el precio pactado de maquila.
            `;
            
            let lines3 = doc.splitTextToSize(nota, 260);
            
            // Calculamos la posición inicial para las notas
            let startY = doc.autoTable.previous.finalY + 10;
            
            // Verificamos si hay espacio suficiente para las notas y la firma
            if (startY + lines3.length * 10 + 20 > pageHeight - marginBottom) {
              doc.addPage(); // Agregar una nueva página si es necesario
              startY = 20; // Reiniciar el inicio de las notas
            }
            
            // Renderizamos las notas
            doc.text(15, startY, lines3);
            
            // Ajustamos la posición de la firma
            let firmaStartY = Math.min(pageHeight - marginBottom, startY + lines3.length * 10 + 10);
            
            doc.setFontSize(18);
            doc.text("Maquilero", 142, firmaStartY + 7);
            doc.setFontSize(12);
            doc.text("___________________", 135, firmaStartY + 0);
            
            // Abre el PDF en una nueva pestaña
            window.open(doc.output("bloburl"), "_blank");
            
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function jalaHabilitacionEdit(id) {
    axios
      .get(`${URL_DETALLE_HABILITACION_CORTES}/proceso/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
          .map((a) => {
            return {
              id: a._id,
              idHabilitacion: a.habilitacion?.[0]?._id,
              nombre: (a.habilitacion?.[0]?.nombre ?? "") + " " + (a.habilitacion?.[0]?.descripcion ?? ""),
              cantidadAnterior: a.cantidad,
              cantidad: a.cantidad
            }
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setEditHab(data);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditHab();
  }

  const handleChangeInputHabilitacionEdit = (id, event) => {
    const newInputFieldsHabilitacion = editHab.map((i) => {
      if (id === i.id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setEditHab(newInputFieldsHabilitacion);
  };

  function saveHabilitacionEdit(event) {
    event.preventDefault();
    let totalRollos = editHab.length;
        editHab.map((a) => {
            axios
              .patch(
                `${URL_DETALLE_HABILITACION_CORTES}/${a.id}`,
                {
                  habilitacion: a.idHabilitacion,
                  cantidad: a.cantidad,
                  cantidadAnterior: a.cantidadAnterior
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`
                  }
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Salida de Habilitacion",
                        detalle: `Pedido`,
                        user: user.id
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`
                        }
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
        });
  }

  function PDFProcesosEntrada(id, numero) {
    axios
      .get(`${URL_PROCESOS_ENTRADA}/corte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosEntrada < b.idProcesosEntrada ? 1 : -1))
          .map((a) => {
            return {
              id: a._id,
              catalogosProcesosName: a.catalogoProcesos?.[0]?.name,
              proveedoresName: a.proveedores?.[0]?.nombre_comercial,
              pedido: a.pedidos?.[0]?.idPedido,
              totalGeneral: a.totalGeneral,
              totalPiezas: a.totalPiezas,
              totalPiezasFaltantes: a.totalPiezasFaltantes,
              totalPiezasSegundas: a.totalPiezasSegundas,
              precio: a.precio,
              numero: a.idProcesosEntrada,
              fecha: a.fecha,
              articulo:
                (a.procesosSalida?.[0]?.articulos?.[0]?.codigo ?? "") +
                " / " +
                (a.procesosSalida?.[0]?.articulos?.[0]?.codigoCliente ?? "")
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setPDFPE(data);
      })
      .catch((err) => {
        console.log(err);
      });
    togglePDFPE();
  }

  async function PDFOCPE(
    id,
    numero,
    proceso,
    maquilero,
    totalPiezas,
    totalPiezasFaltantes,
    totalPiezasSegundas,
    precio,
    fecha,
    totalGeneral
  ) {
    await axios
      .get(`${URL_ARTICULOS_PROCESOS_ENTRADA}/proceso/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`
        }
      })
      .then((response) => {
        let allArticulosCorte = response.data;
        let arrayTabla = allArticulosCorte
          .map((a) => {
            return [
              (a.articulosPedido?.[0]?.articulos?.[0]?.codigoCliente ?? "") +
                " " +
                (a.articulosPedido?.[0]?.articulos?.[0]?.codigo ?? "") +
                " " +
                (a.articulosPedido?.[0]?.articulos?.[0]?.descripcion ?? ""),
              a.articulosPedido?.[0]?.colores?.[0]?.name,
              a.articulosPedido?.[0]?.tallas?.[0]?.name,
              a.cantidadEntrada,
              a.cantidadFaltantes,
              a.cantidadSegundas,
            ];
          })
          .filter(function (el) {
            return el != null;
          });

        const dataPDF = Object.values(arrayTabla);

        const doc = new jsPDF();
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 150, 10, 33, 10);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 160, 23, 25, 25);
        doc.text(`Maquilero ${maquilero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Proceso Entrada ${proceso}`, 20, 30);
        doc.text(`Precio $${precio}`, 20, 35);
        doc.text(
          `Total ${new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2
          }).format(totalGeneral)}`,
          20,
          40
        );
        doc.text(
          `Total Cantidad ${new Intl.NumberFormat("en-US", {}).format(
            totalPiezas + totalPiezasFaltantes + totalPiezasSegundas
          )}`,
          20,
          45
        );
        doc.autoTable({
          head: [
            [
              "Articulo",
              "Color",
              "Talla",
              "Cantidad",
              "Faltante Hab",
              "Segundas",
            ],
          ],
          body: dataPDF,
          startY: 50,
          foot: [
            [
              "",
              "",
              "Total",
              new Intl.NumberFormat("en-US").format(totalPiezas),
              new Intl.NumberFormat("en-US").format(totalPiezasFaltantes),
              new Intl.NumberFormat("en-US").format(totalPiezasSegundas),
            ],
          ],
          showFoot: "lastPage"
        });
        // doc.save(`ProcesoEntrada-${numero}.pdf`);

        window.open(doc.output("bloburl"), "_blank");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const sortedInputFields = [...inputFields].sort((a, b) => {
    // Primero ordenar por color
    if (a.colores > b.colores) return 1;
    if (a.colores < b.colores) return -1;
  
    // Si los colores son iguales, ordenar por el orden de tallas
    const indexA = ordenTallas.indexOf(a.tallas);
    const indexB = ordenTallas.indexOf(b.tallas);
  
    // Si ambas tallas están en el orden definido
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
  
    // Si alguna talla no está en el orden definido, ponerla al final
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
  
    return 0;
  });

  const sortedArticulosCortesEntrada = [...articulosCortesEntrada].sort((a, b) => {
    // Primero ordenar por color
    if (a.color > b.color) return 1;
    if (a.color < b.color) return -1;
  
    // Si los color son iguales, ordenar por el orden de tallas
    const indexA = ordenTallas.indexOf(a.talla);
    const indexB = ordenTallas.indexOf(b.talla);
  
    // Si ambas tallas están en el orden definido
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
  
    // Si alguna talla no está en el orden definido, ponerla al final
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
  
    return 0;
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.corteCreate ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/CortesCreate"
                >
                  Nueva Corte
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Corte
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuProduccion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-cut" style={{ marginRight: 8, color: "#8b5cf6" }} />
                Cortes
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
      key={a.id}
      style={{
        backgroundColor: a.statusTela === "Completo" ? "#a8d5ba" : a.statusTela === "Incompleto" ? "#ed8c8c" : "transparent",
        color: "white", // Para asegurarte de que el texto sea legible en fondo verde o rojo
      }}
    >
                      <td>{a.ordenCorte}</td>
                      <td>{a.folioCAV}</td>
                      <td>{a.fecha}</td>
                      <td>{a.maquilero}</td>
                      <td>{a.cliente}</td>
                      <td>{a.comprador}</td>
                      <td>{a.codigo}</td>
                      <td>{a.articulo}</td>
                      {/* <td>{a.marca}</td> */}
                      <td>{a.fechaCancelacionPedido}</td>
                      <td>{a.total_cantidad}</td>
                      <td>{a.recibido}</td>
                      <td style={{ color: a.faltante > 0 ? "#dc2626" : undefined, fontWeight: a.faltante > 0 ? 600 : undefined }}>
                        {a.faltante}
                      </td>
                      <td>{a.cantidadPedido}</td>
                      <td>{a.fechaCompromiso}</td>
                      <td>{a.precioMaquila}</td>
                      <td>{a.consumoRealPrenda}</td>
                      <td>{a.observaciones}
                      <Button title="Editar"
                      color="info"
                      id="Editar"
                      size="sm"
                      style={{ marginLeft: '10px' }}
                      onClick={(e) => {
                        observacionesEditar(a._id, a.observaciones, a.statusTela);
                      }}
                    >
                      <i class="far fa-edit"></i>
                    </Button>

                      </td>

                      <td>{a.observacionesMaquila}
                      <Button title="Editar"
                      color="info"
                      id="Editar"
                      size="sm"
                      style={{ marginLeft: '10px' }}
                      onClick={(e) => {
                        observacionesMaquilaEditar(a._id, a.observacionesMaquila);
                      }}
                    >
                      <i class="far fa-edit"></i>
                    </Button>

                      </td>
                      <td>
                        <Button title="PDF"
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={(e) =>
                            PDFOC(
                              a.numero,
                              a.fecha,
                              a.ordenCorte,
                              a.maquilero,
                              a.total_cantidad,
                              a._id,
                              a.fechaCompromiso,
                              a.precioMaquila,
                              a.observaciones
                            )
                          }
                        >
                          <i class="far fa-file-pdf"></i>
                        </Button>
                        <Button
                          size="sm"
                          className="btn"
                          color="info"
                          style={{ marginLeft: 4 }}
                          title="Editar orden de producción (lo que sale en el PDF)"
                          onClick={() => setOrdenEditar(a)}
                        >
                          <i class="far fa-edit"></i>
                        </Button>
                      </td>
                      {a.status == "Abierto" && a.is_active == "Si" ? (
                        <>
                          <td>
                            <Button title="Entrada a almacén"
                              size="sm"
                              className="btn btn-success"
                              onClick={(e) =>
                                entradaAlmacen(a._id, a.numero)
                              }
                            >
                              <i class="fas fa-tshirt"></i>
                            </Button>
                            <Button
                              size="sm"
                              className="btn"
                              color={a.avisoPendiente ? "warning" : "secondary"}
                              title={
                                a.avisoPendiente
                                  ? `Aviso ${a.avisoPendiente.numero} pendiente: ${a.avisoPendiente.total} pzas`
                                  : "Capturar aviso de entrega del maquilero"
                              }
                              onClick={(e) => abrirAviso(a._id, a.numero)}
                            >
                              <i class="fas fa-bell"></i>
                              {a.avisoPendiente ? ` ${a.avisoPendiente.total}` : ""}
                            </Button>
                          </td>
                        </>
                      ) : (
                        <td></td>
                      )}
                      <td>
                        <Status
                          idStatus={a._id}
                          status={a.status}
                          URL_STATUS={process.env.REACT_APP_URL_CORTES}
                        />
                         <BajaMultiple
                              idStatus={a._id}
                              is_active={a.is_active}
                              URL_BAJA={process.env.REACT_APP_URL_CORTES}
                              hijo={`${process.env.REACT_APP_URL_ARTICULOS_CORTES}/baja`}
                            />
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>
          <h4>Enviar Listado Cortes</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41"
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41"
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41"
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalProcesosSalida}
        toggle={toggleProcesosSalida}
      >
        <ModalHeader toggle={toggleProcesosSalida}>
          <h4>Procesos Corte {selectedCorteNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Articulo</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={8}>
              <Label className="mr-sm-2">Procesos</Label>
            </Col>
          </Row>
          {articulosUnicos.map((a) => (
            <div key={a.id}>
              <Row>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="articulos"
                    type="text"
                    value={a.articuloNombre}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="articulos"
                    type="text"
                    value={a.total_cantidad}
                    disabled
                  />
                </Col>
                <Col md={8}>
                  {a.catalogoProcesos.map((p) => (
                    <Button
                      size="sm"
                      className="btn btn-success"
                      onClick={(e) =>
                        funcionProcesosSalida(
                          p._id,
                          p.name,
                          a.idArticulo,
                          a.articuloNombre,
                          a.idPedido,
                          a.numeroPedido,
                          a.fechaCancelacion
                        )
                      }
                    >
                      {p.name}
                    </Button>
                  ))}
                </Col>
              </Row>
            </div>
          ))}
        </ModalBody>
      </Modal>

      <Modal
        size="xl"
        isOpen={modalFuncionProcesosSalida}
        toggle={toggleFuncionProcesosSalida}
      >
        <ModalHeader toggle={toggleFuncionProcesosSalida}>
          <h4>
            Proceso Salida: {nombreProcesosSalida} <br />
            Articulo: {nombreArticulo} <br />
            Pedido: {numeroPedido} <br />
            Fecha Cancelacion: {fechaCancelacion}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveSalidaProceso}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaProceso}
                  required
                  onChange={(e) => {
                    setFechaProceso(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  placeholder="FechaCompromiso"
                  value={fechaCompromisoProceso}
                  required
                  onChange={(e) => {
                    setFechaCompromisoProceso(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Maquilero</Label>
                <Input
                  type="select"
                  placeholder="Maquilero"
                  value={maquileroProceso}
                  required
                  onChange={(e) => {
                    setMaquileroProceso(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      if (a.tipo == "Maquilero") {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      }
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Precio</Label>
                <Input
                  // bsSize="sm"
                  name="precio"
                  type="number"
                  placeholder="Precio"
                  value={precioProceso}
                  required
                  onChange={(event) => handleChangeInputPrecio(event)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={12}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>
            {sortedInputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="color"
                      type="text"
                      value={inputField.colores}
                      disabled
                    />
                  </Col>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="talla"
                      type="text"
                      value={inputField.tallas}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={inputField.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidadPS(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="total"
                      type="number"
                      value={inputField.total}
                      disabled
                    />
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            <Row>
              <Col md={4}></Col>
              <Col md={4}>
                <h4>TOTALES</h4>
              </Col>
              <Col md={2}>
                <h4>{totalPiezas}</h4>
              </Col>
              <Col md={2}>
                <h4>{totalGeneral}</h4>
              </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      {/* Procesos Entrada */}
      <Modal
        size="xxl"
        isOpen={modalProcesosEntrada}
        toggle={toggleProcesosEntrada}
      >
        <ModalHeader toggle={toggleProcesosEntrada}>
          <h4>Procesos Corte {selectedCorteNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={2}>
              <Label className="negrita">Articulo</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Proceso</Label>
            </Col>
            <Col md={2}>
              <Label className="negrita">Maquilero</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Fecha Salida</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Compromiso</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Precio</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Salida</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Entrada</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Recibir</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Cerrar</Label>
            </Col>
          </Row>
          {articulosUnicosEntrada.map((a) => (
            <div key={a.id}>
              <Row>
                <Col md={2}>
                  {" "}
                  <Label> {a.articuloNombre}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>{a.catalogoProcesos}</Label>
                </Col>
                <Col md={2}>
                  {" "}
                  <Label>{a.maquilero}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>{a.fecha}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>{a.fechaCompromiso}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>$ {a.precio}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>{a.cantidadSalida}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>{a.cantidadEntrada}</Label>
                </Col>
                <Col md={1}>
                  {a.status == "Cerrado" || a.faltantes <= 0 ? undefined : (
                    <Button title="Entrada de procesos"
                      color="primary"
                      size="sm"
                      className="btn btn-success"
                      onClick={(e) =>
                        funcionProcesosEntrada(
                          a.idCatalogoProcesos,
                          a.catalogoProcesos,
                          a.idArticulo,
                          a.articuloNombre,
                          a.idPedido,
                          a.numeroPedido,
                          a.procesosSalida
                        )
                      }
                    >
                      <i class="fas fa-sign-in-alt"></i>
                    </Button>
                  )}
                </Col>
                <Col md={1}>
                  {a.status == "Cerrado" ? undefined : (
                    <Button title="Cerrar"
                      color="primary"
                      size="sm"
                      className="btn btn-success"
                      onClick={(e) =>
                        cerrarProcesosEntrada(
                          a.procesosSalida,
                          a.faltantes,
                          a.faltantesHab,
                          a.idMaquilero
                        )
                      }
                    >
                      <i class="fas fa-lock"></i>
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          ))}
        </ModalBody>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalFuncionProcesosEntrada}
        toggle={toggleFuncionProcesosEntrada}
      >
        <ModalHeader toggle={toggleFuncionProcesosEntrada}>
          <h4>
            Proceso: {nombreProcesosEntrada} <br />
            Articulo: {nombreArticulo} <br />
            Pedido: {numeroPedido}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveEntradaProceso}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaProceso}
                  required
                  onChange={(e) => {
                    setFechaProceso(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Maquilero</Label>
                <Input
                  type="select"
                  placeholder="Maquilero"
                  value={maquileroProceso}
                  required
                  disabled
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      if (a.tipo == "Maquilero") {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      }
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Precio</Label>
                <Input
                  // bsSize="sm"
                  name="precio"
                  type="number"
                  placeholder="Precio"
                  value={precioProceso}
                  required
                  onChange={(event) => handleChangeInputPrecio(event)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={12}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Faltante Hab</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Segundas</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>
            {sortedInputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="color"
                      type="text"
                      value={inputField.colores}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="talla"
                      type="text"
                      value={inputField.tallas}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={inputField.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="faltantes"
                      type="number"
                      value={inputField.faltantes}
                      onChange={(event) =>
                        handleChangeInputCantidadFDS(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="segundas"
                      type="number"
                      value={inputField.segundas}
                      onChange={(event) =>
                        handleChangeInputCantidadFDS(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="total"
                      type="number"
                      value={inputField.total}
                      disabled
                    />
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            <Row>
              <Col md={2}></Col>
              <Col md={2}>
                <h4>TOTALES</h4>
              </Col>
              <Col md={2}>
                <h4>{totalPiezas}</h4>
              </Col>
              <Col md={2}>
                <h4>{totalPiezasFaltantes}</h4>
              </Col>
              <Col md={2}>
                <h4>{totalPiezasSegundas}</h4>
              </Col>
              <Col md={2}>
                <h4>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2
                  }).format(totalGeneral)}
                </h4>
              </Col>
            </Row>
            <Row>
              <Col md={2}></Col>
              <Col md={2}>
                <h4>TOTAL CANTIDAD</h4>
              </Col>
              <Col md={2}>
                <h4>
                  {totalPiezas + totalPiezasFaltantes + totalPiezasSegundas}
                </h4>
              </Col>
            </Row>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalFaltante} toggle={toggleFaltante}>
        <ModalHeader toggle={toggleFaltante}></ModalHeader>
        <ModalBody>
          <Form onSubmit={saveFaltantes}>
            <Row>
              <h4>Faltantes Maquileros</h4>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Fecha</Label>
                <Input
                  bsSize="sm"
                  name="fecha"
                  type="date"
                  required
                  value={fechaFaltante}
                  onChange={(event) => {
                    setFechaFaltante(event.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <Label>Faltantes</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={cantidadFaltante}
                  onChange={(event) => {
                    setCantidadFaltante(event.target.value);
                    setTotalFaltante(event.target.value * precioFaltante);
                    setTotalTotalFaltante(
                      event.target.value * precioFaltante + totalFaltanteHab
                    );
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Precio</Label>
                <Input
                  bsSize="sm"
                  name="precio"
                  type="number"
                  value={precioFaltante}
                  onChange={(event) => {
                    setPrecioFaltante(event.target.value);
                    setTotalFaltante(event.target.value * cantidadFaltante);
                    setTotalTotalFaltante(
                      event.target.value * cantidadFaltante + totalFaltanteHab
                    );
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Total</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={totalFaltante}
                  disabled
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <Label>Faltantes Habilitacion</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={cantidadFaltanteHab}
                  onChange={(event) => {
                    setCantidadFaltanteHab(event.target.value);
                    setTotalFaltanteHab(event.target.value * precioFaltanteHab);
                    setTotalTotalFaltante(
                      event.target.value * precioFaltanteHab + totalFaltante
                    );
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Precio</Label>
                <Input
                  bsSize="sm"
                  name="precio"
                  type="number"
                  value={precioFaltanteHab}
                  onChange={(event) => {
                    setPrecioFaltanteHab(event.target.value);
                    setTotalFaltanteHab(
                      event.target.value * cantidadFaltanteHab
                    );
                    setTotalTotalFaltante(
                      event.target.value * cantidadFaltanteHab + totalFaltante
                    );
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Total</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={totalFaltanteHab}
                  disabled
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={8}></Col>
              <Col md={4}>
                <Label>Total por Aplicar</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={totalTotalFaltante}
                  disabled
                />
              </Col>
            </Row>

            <Button type="submit" className="btn btn-success">
              Guardar
            </Button>
          </Form>
        </ModalBody>
      </Modal>

      {/* Aviso previo del maquilero */}
      <Modal size="lg" isOpen={modalAviso} toggle={() => setModalAviso(false)}>
        <ModalHeader toggle={() => setModalAviso(false)}>
          <h4>Aviso de entrega · Orden {avisoCorte.numero}</h4>
        </ModalHeader>
        <ModalBody>
          {avisoPendiente ? (
            <>
              <p>
                Esta orden ya tiene el aviso <b>{avisoPendiente.idAvisoEntrega}</b> pendiente
                ({avisoPendiente.fecha}) por <b>{avisoPendiente.total}</b> pzas. La entrada al
                almacen se abrira con esas cantidades.
              </p>
              <Button color="danger" onClick={cancelarAviso}>
                Cancelar aviso
              </Button>
            </>
          ) : (
            <>
              <p className="text-muted">
                Captura lo que el maquilero avisa que va a entregar. No mueve inventario: la
                entrada al almacen se abrira prellenada con esto.
              </p>
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Color</th>
                      <th>Talla</th>
                      <th>Mandado</th>
                      <th>Faltante</th>
                      <th>Va a entregar</th>
                      <th>Segundas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {avisoRenglones.map((r) => (
                      <tr key={r.id}>
                        <td>{r.color}</td>
                        <td>{r.talla}</td>
                        <td>{r.mandado}</td>
                        <td>{r.faltante}</td>
                        <td style={{ width: 110 }}>
                          <Input bsSize="sm" type="number" min={0} value={r.cantidad}
                            onChange={(e) => cambiaAviso(r.id, "cantidad", e.target.value)} />
                        </td>
                        <td style={{ width: 110 }}>
                          <Input bsSize="sm" type="number" min={0} value={r.segundas}
                            onChange={(e) => cambiaAviso(r.id, "segundas", e.target.value)} />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={4}><b>TOTAL</b></td>
                      <td><b>{avisoRenglones.reduce((t, r) => t + r.cantidad, 0)}</b></td>
                      <td><b>{avisoRenglones.reduce((t, r) => t + r.segundas, 0)}</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Label>Observaciones</Label>
              <Input type="text" value={avisoObservaciones} onChange={(e) => setAvisoObservaciones(e.target.value)} />
              <br />
              <Button color="success" onClick={guardarAviso}>
                Guardar aviso
              </Button>
            </>
          )}
        </ModalBody>
      </Modal>

      {/* Entrada Almacen */}

      <Modal
        size="xxl"
        isOpen={modalEntradaAlmacen}
        toggle={toggleEntradaAlmacen}
      >
        <ModalHeader toggle={toggleEntradaAlmacen}>
          <h3>Entrada Almacen</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveEntradaAlma}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaEntradaAlma}
                  required
                  onChange={(e) => {
                    setFechaEntradaAlma(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Almacen</Label>
                <Input
                  type="select"
                  value={areasEntrada}
                  required
                  onChange={(e) => {
                    setAreasEntrada(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {areas.map((a) => {
                    if (a.name != "General") {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
                </Input>
              </Col>

              <Col md={3}>
                <Label>Codigo SAT</Label>
                <Input
                  type="select"
                  placeholder="CodigoSAT"
                  value={codigoSAT}
                  required
                  onChange={(e) => {
                    setCodigoSAT(e.target.value);
                  }}
                  >
                    <option value="">Selecciona</option>
                    <option value="53101604">53101604</option>
                    <option value="53102002">53102002</option>
                    <option value="53101504">53101504</option>
                    <option value="53101804">53101804</option>
                    <option value="53101704">53101704</option>
                    <option value="53103100">53103100</option>
                    <option value="53102800">53102800</option>
                    <option value="1010101">1010101</option>
                  </Input>
              </Col>
              <Col md={3}>
                <Label>Codigo Unidad</Label>
                <Input
                  type="string"
                  placeholder="CodigoUnidad"
                  value={codigoUnidad}
                  required
                  onChange={(e) => {
                    setCodigoUnidad(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={12}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            {avisoEntrada ? (
              <p style={{ background: "#fef3c7", padding: "8px 12px", borderRadius: 6 }}>
                Prellenado con el aviso <b>{avisoEntrada.idAvisoEntrega}</b> del maquilero
                ({avisoEntrada.fecha}, {avisoEntrada.total} pzas). Corrige lo que haya llegado distinto.
              </p>
            ) : undefined}
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Mandado</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Faltante</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Segundas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Quedara</Label>
              </Col>
            </Row>
            {sortedArticulosCortesEntrada.map((a) => (
              <div key={a.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articuloNombre"
                      type="text"
                      value={a.articuloNombre}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="color"
                      type="text"
                      value={a.color}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="talla"
                      type="text"
                      value={a.talla}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input bsSize="sm" type="text" value={a.mandado} disabled />
                  </Col>
                  <Col md={1}>
                    <Input bsSize="sm" type="text" value={a.faltante} disabled />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={a.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidadEntradaAlma(a.id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="segundas"
                      type="number"
                      value={a.segundas}
                      onChange={(event) =>
                        handleChangeInputEntradaSegundasAlma(a.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    {(() => {
                      // Lo que seguira faltando despues de esta entrada.
                      const queda = (a.faltante || 0) - (parseFloat(a.cantidad) || 0) - (parseFloat(a.segundas) || 0);
                      return (
                        <Input bsSize="sm" type="text" disabled value={queda}
                          style={{ color: queda < 0 ? "#b45309" : queda > 0 ? "#dc2626" : "#16a34a", fontWeight: 600 }} />
                      );
                    })()}
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            <Row>
              <Col md={6}></Col>
              <Col md={1}>
                <h4>TOTAL</h4>
              </Col>
              <Col md={2}>
                <h4>{totalPiezasEntradaAlma}</h4>
              </Col>
              <Col md={2}>
                <h4>{totalPiezasEntradaSegundasAlma}</h4>
              </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      {/* PDFPS */}
      <Modal size="xxl" isOpen={modalPDFPS} toggle={togglePDFPS}>
        <ModalHeader toggle={togglePDFPS}>
          <h3>Detalle Salida Procesos</h3>
        </ModalHeader>
        <ModalBody>
          <Table>
            <tr>
              <th>#</th>
              <th>Proceso</th>
              <th>Proveedor</th>
              <th>Articulo</th>
              <th>Pedido</th>
              <th>Fecha Comp.</th>
              <th>Piezas</th>
              {/* <th>Precio</th>
              <th>Total</th> */}
              <th>Habilitacion</th>
              <th>PDF</th>
            </tr>
            {PDFPS.map((a) => {
              return (
                <tr>
                  <td>{a.numero}</td>
                  <td>{a.catalogosProcesosName}</td>
                  <td>{a.proveedoresName}
                  <Button title="Editar"
                      color="info"
                      id="Editar"
                      size="sm"
                      style={{ marginLeft: '10px' }}
                      onClick={(e) => {
                        maquileroEdit(a.id, a.idProveedor, a.precio, a.fechaCompromiso, a.fecha, a.observaciones, a.idCorte);
                      }}
                    >
                      <i class="far fa-edit"></i>
                    </Button>
                    </td>
                  <td>{a.articulo}</td>
                  <td>{a.pedido}</td>
                  <td>{a.fechaCompromiso}</td>
                  <td>{a.totalPiezas}</td>
                  {/* <td>{a.precio}</td>
                  <td>
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2
                    }).format(a.totalGeneral)}
                  </td> */}
                  <td>
                    <Button title="Habilitación"
                      size="sm"
                      className="btn"
                      color="success"
                      onClick={(e) =>
                        jalaHabilitacion(
                          a.id,
                          a.idArticulo,
                          a.numero,
                          a.catalogosProcesosName,
                          a.proveedoresName,
                          a.idProveedor,
                          a.pedido,
                          a.idPedido,
                          a.fechaCompromiso,
                          a.totalPiezas,
                          a.precio,
                          a.totalGeneral,
                          a.fecha,
                          a.idCorte,
                          a.numeroCorte
                        )
                      }
                    >
                      <i class="fas fa-tag"></i>
                    </Button>
                    <Button title="Editar"
                      color="info"
                      id="Editar"
                      size="sm"
                      onClick={(e) => {
                        jalaHabilitacionEdit(a.id);
                      }}
                    >
                      <i class="far fa-edit"></i>
                    </Button>
                  </td>
                  <td>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={(e) =>
                        PDFOCPS(
                          a.id,
                          a.numero,
                          a.catalogosProcesosName,
                          a.proveedoresName,
                          a.pedido,
                          a.fechaCompromiso,
                          a.totalPiezas,
                          a.precio,
                          a.totalGeneral,
                          a.fecha,
                          a.idArticulo,
                          a.descripcion,
                          a.ordenCorte,
                          a.articulo,
                          a.cliente,
                          a.observacionesProceso
                        )
                      }
                    >
                      <i class="far fa-file-pdf"> $ </i>
                    </Button>

                    <Button title="PDF"
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={(e) =>
                        PDFOCPSSinPrecio(
                          a.id,
                          a.numero,
                          a.catalogosProcesosName,
                          a.proveedoresName,
                          a.pedido,
                          a.fechaCompromiso,
                          a.totalPiezas,
                          a.precio,
                          a.totalGeneral,
                          a.fecha,
                          a.idArticulo,
                          a.descripcion,
                          a.ordenCorte,
                          a.articulo,
                          a.cliente,
                          a.observacionesProceso
                        )
                      }
                    >
                      <i class="far fa-file-pdf"></i>
                    </Button>
                  </td>
                </tr>
              );
            })}
          </Table>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalPDFPE} toggle={togglePDFPE}>
        <ModalHeader toggle={togglePDFPE}>
          <h3>Detalle Entrada Procesos</h3>
        </ModalHeader>
        <ModalBody>
          <Table>
            <tr>
              <th>#</th>
              <th>Proceso</th>
              <th>Proveedor</th>
              <th>Articulo</th>
              <th>Pedido</th>
              <th>Fecha</th>
              <th>Piezas</th>
              <th>Faltantes Heb</th>
              <th>Segundas</th>
              <th>Precio</th>
              <th>Total</th>
              <th>PDF</th>
            </tr>
            {PDFPE.map((a) => {
              return (
                <tr>
                  <td>{a.numero}</td>
                  <td>{a.catalogosProcesosName}</td>
                  <td>{a.proveedoresName}</td>
                  <td>{a.articulo}</td>
                  <td>{a.pedido}</td>
                  <td>{a.fecha}</td>
                  <td>{a.totalPiezas}</td>
                  <td>{a.totalPiezasFaltantes}</td>
                  <td>{a.totalPiezasSegundas}</td>
                  <td>
                    {" "}
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2
                    }).format(a.precio)}
                  </td>
                  <td>
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2
                    }).format(a.totalGeneral)}
                  </td>
                  <td>
                    <Button title="PDF"
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={(e) =>
                        PDFOCPE(
                          a.id,
                          a.numero,
                          a.catalogosProcesosName,
                          a.proveedoresName,
                          a.totalPiezas,
                          a.totalPiezasFaltantes,
                          a.totalPiezasSegundas,
                          a.precio,
                          a.fecha,
                          a.totalGeneral
                        )
                      }
                    >
                      <i class="far fa-file-pdf"></i>
                    </Button>
                  </td>
                </tr>
              );
            })}
          </Table>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalHabilitacion} toggle={toggleHabilitacion}>
        <ModalHeader toggle={toggleHabilitacion}>
          <h3>Entregar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveHabilitacion}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={fechaHab}
                  onChange={(event) => {
                    setFechaHab(event.target.value);
                  }}
                ></Input>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col md={4}>
                <Label>Tipo de habilitación</Label>
                <FiltroTipoHabilitacion bsSize="sm" value={filtroTipoHab} onChange={setFiltroTipoHab} />
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFieldsHabilitacion.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={8}>
                    <Input
                      bsSize="sm"
                      name="idHabilitacion"
                      type="select"
                      value={inputField.idHabilitacion}
                      onChange={(event) => {
                        handleChangeInputHabilitacion(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {habilitacion
                        .filter((a) => a._id === inputField.idHabilitacion || coincideTipo(a, filtroTipoHab))
                        .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.descripcion} {a.nombre}</option>;
                        })}
                    </Input>
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={inputField.cantidad}
                      onChange={(event) => {
                        handleChangeInputHabilitacion(inputField.id, event);
                      }}
                    ></Input>
                  </Col>

                  <Col>
                    <Button title="Quitar renglón"
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFieldsHabilitacion.length === 1}
                      onClick={() =>
                        handleRemoveFieldsHabilitaccion(inputField.id)
                      }
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button title="Agregar renglón"
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsHabilitacion}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalEditHab} toggle={toggleEditHab}>
        <ModalHeader toggle={toggleEditHab}>
          <h3><i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />Editar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form
          onSubmit={saveHabilitacionEdit}
          >
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-list" />
              <span className="form-section-title">Detalle</span>
            </div>
            <div className="form-section-body">
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Anterior</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Nueva</Label>
              </Col>
            </Row>

            {editHab.map((a) => (
              <div key={a.id}>
                <Row>
                  <Col md={8}>
                    <Input
                      bsSize="sm"
                      name="nombre"
                      type="string"
                      value={a.nombre}
                      disabled
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidadAnterior}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidad}
                      onChange={(event) => {
                        handleChangeInputHabilitacionEdit(a.id, event);
                      }}
                    ></Input>
                  </Col>
                </Row>
              </div>
            ))}
            </div>
          </div>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>


      <Modal size="lg" isOpen={modalMaquileroEdit} toggle={toggleMaquileroEdit}>
        <ModalHeader toggle={toggleMaquileroEdit}>
          <h3><i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />Editar Maquilero</h3>
        </ModalHeader>
        <ModalBody>
          <Form
          onSubmit={saveMaquileroEdit}
          >
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-industry" />
              <span className="form-section-title">Datos</span>
            </div>
            <div className="form-section-body">
            <Row>
          <Col md={6}>
                <Label>Maquilero</Label>
                <Input
                  type="select"
                  placeholder="Maquilero"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      if (a.tipo == "Maquilero") {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      }
                    })}
                </Input>
              </Col>
              <Col md={6}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaEdit}
                  required
                  onChange={(e) => {
                    setFechaEdit(e.target.value);
                  }}
                />
              </Col>
              </Row>
              <Row>
              <Col md={6}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaCompromisoEdit}
                  required
                  onChange={(e) => {
                    setFechaCompromisoEdit(e.target.value);
                  }}
                />
              </Col>

              <Col md={6}>
                <Label>Precio</Label>
                <Input
                  type="number"
                  placeholder="Precio"
                  value={precioEdit}
                  required
                  onChange={(e) => {
                    setPrecioEdit(e.target.value);
                  }}
                />
              </Col>
              </Row>
            </div>
          </div>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-comment-dots" />
              <span className="form-section-title">Observaciones</span>
            </div>
            <div className="form-section-body">
            <Row>
              <Col md={12}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  placeholder="observaciones"
                  value={observacionesEditProceso}
                  required
                  onChange={(e) => {
                    setObservacionesEditProceso(e.target.value);
                  }}
                />
              </Col>
              </Row>
            </div>
          </div>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>


      <Modal size="lg" isOpen={modalObservacionesEdit} toggle={toggleObservacionesEdit}>
        <ModalHeader toggle={toggleObservacionesEdit}>
          <h3><i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />Editar Observaciones</h3>
        </ModalHeader>
        <ModalBody>
          <Form
          onSubmit={saveObservacionesEdit}
          >
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-comment-dots" />
              <span className="form-section-title">Datos</span>
            </div>
            <div className="form-section-body">
          <Row>
          <Col md={6}>
                <Label>Status</Label>
                <Input
                  type="select"
                  placeholder="Maquilero"
                  value={statusTelaEdit}
                  required
                  onChange={(e) => {
                    setStatusTelaEdit(e.target.value);
                  }}
                >
                  <option value="Pendiente">Pendiente</option>
                  <option value="Completo">Completo</option>
                  <option value="Incompleto">Incompleto</option>
                </Input>
              </Col>
              </Row>
            <Row>
          <Col md={12}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  placeholder="Maquilero"
                  value={observacionesEdit}
                  required
                  onChange={(e) => {
                    setObservacionesEdit(e.target.value);
                  }}
                />
              </Col>
              </Row>
            </div>
          </div>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>


            <Modal size="lg" isOpen={modalObservacionesMaquilaEdit} toggle={toggleObservacionesMaquilaEdit}>
        <ModalHeader toggle={toggleObservacionesMaquilaEdit}>
          <h3><i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />Editar Observaciones</h3>
        </ModalHeader>
        <ModalBody>
          <Form
          onSubmit={saveObservacionesMaquilaEdit}
          >
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-comment-dots" />
              <span className="form-section-title">Datos</span>
            </div>
            <div className="form-section-body">
            <Row>
          <Col md={12}>
                <Label>ObservacionesMaquila</Label>
                <Input
                  type="text"
                  placeholder="Maquilero"
                  value={observacionesMaquilaEdit}
                  required
                  onChange={(e) => {
                    setObservacionesMaquilaEdit(e.target.value);
                  }}
                />
              </Col>
              </Row>
            </div>
          </div>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>
      <EditarOrdenProduccion
        isOpen={!!ordenEditar}
        toggle={() => setOrdenEditar(null)}
        idCorte={ordenEditar && ordenEditar._id}
        onGuardado={() => setRecargarListado((n) => n + 1)}
        onVerPdf={() => {
          const a = ordenEditar;
          PDFOC(a.numero, a.fecha, a.ordenCorte, a.maquilero, a.total_cantidad, a._id);
        }}
      />
      {loader}
    </>
  );
}

export default ListadoCortes;
